import React, { useEffect, useRef, useState } from 'react';
import ImModuleStyle from '../styles/im.module.css';
import Button from '../../common/Button';
import help from '../../../assets/help.png';
import { useOutletContext } from "react-router-dom";
import info from '../assets/info.png';
import ReactDOM from 'react-dom';
import { get_prework, nextday_prework, retry_prework } from '../services/api';
import { getSession, setSession } from '../../../App';

const Prework = ({from,data}) => {
    const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, calculatorPopup, setCalculatorPopup, kpisPopup, setKpisPopup, relaunchPopup, setRelaunchPopup, expandCalcPopup, setExpandCalcPopup] = useOutletContext();
    const [isCalculatorOpen, setIsCalculatorOpen] = useState(false);
    const [isFromHelp, setIsFromHelp] = useState(false);
    let qd = 0, qs = 0, qh = 0, dd = 0, dw = 0, ropd = 0, ropl = 0;
    const [calculator, setCalculator] = useState({ qd: qd, qs: qs, qh: qh, dd: dd, dw: dw, ropd: ropd, ropl: ropl });
    //Activity 1 Calculator
    const [calculator1, setCalculator1] = useState({
        qd1: { istrue: false, value: '' },
        qs1: { istrue: false, value: '' },
        qh1: { istrue: false, value: '' },
        dd1: { istrue: false, value: '' },
        dw1: { istrue: false, value: '' },
        ropd1: { istrue: false, value: '' },
        ropl1: { istrue: false, value: '' }
      });
    const [accordion_Popup, setAccordion_Popup] = useState(false);
    // const [data, setData] = useState([]); // Initializing state with preworkTableData
    const [currentIndex, setCurrentIndex] = useState(1);
    const [tdordered, setTdOrdered] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [preworkValues,setPreworkValues]=useState({"preworkTableData":[]})
    const [prework, setPrework] = useState({});
    const [tdreceived, setTdReceived] = useState({});
    const [isSubmit, setIsSubmit] = useState(false);
    const [isSubmitted,setIssubmitted]=useState(false); //final save call
    const shouldRunEffect = useRef(true); // stop rerendering activity 1
    const hasSubmitted=useRef(false);
    const [nextRowToAdd,setNextRowToAdd] = useState({})
    const [defaultPreworkData,setDefaultPreworkData]=useState({});
    const [resetAllData,setResetAllData]=useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [qty,setQty]=useState(false);
    const isDataLoaded = useRef(false);
    const isRowSaved = useRef(false);
    const clickInProgress = useRef(false);
    const orderDisabled=useRef(false);
    const [isSave,setIsSave]=useState(false);
    const [isRequestLoading,setIsRequestLoading] = useState(false);
    const [isStepsContainerOpen, setIsStepsContainerOpen] = useState(true);
    const [isScenarioContainerOpen, setIsScenarioContainerOpen] = useState(true);
    const [isApproachOpen, setIsApproachOpen] = useState(true);
    const [isActivity1Open, setIsActivity1Open] = useState(true);
    const [isActivity2Open, setIsActivity2Open] = useState(true);
    //Calculator Popup Top
    const [calculatorQPopupTop, setCalculatorQPopupTop] = useState(0);
    const [calculatorQdPopupTop, setCalculatorQdPopupTop] = useState(0);
    const [calculatorDivdPopupTop, setCalculatorDivdPopupTop] = useState(0);
    const [calculatorQsPopupTop, setCalculatorQsPopupTop] = useState(0);
    const [calculatorQhPopupTop, setCalculatorQhPopupTop] = useState(0);
    const [calculatorQ1PopupTop, setCalculatorQ1PopupTop] = useState(0);
    const [calculatorDdPopupTop, setCalculatorDdPopupTop] = useState(0);
    const [calculatorDwPopupTop, setCalculatorDwPopupTop] = useState(0);
    const [calculatorD1PopupTop, setCalculatorD1PopupTop] = useState(0);
    const [calculatorRopPopupTop, setCalculatorRopPopupTop] = useState(0);
    const [calculatorRopdPopupTop, setCalculatorRopdPopupTop] = useState(0);
    const [calculatorRoplPopupTop, setCalculatorRoplPopupTop] = useState(0);
    const [calculatorRopl1PopupTop, setCalculatorRopl1PopupTop] = useState(0);
    const isToActivateToaster = useRef(false);
    const currDateRef= useRef(null);
    const isRowAdded = useRef(false);
    let currentMonthDates;
    let maximumPlacedOrder = 0, minimumPlacedOrder = 0;
    let analystDate = new Date();
    let currentMonth = analystDate.getMonth();
    let nextMonth = new Date(analystDate.getFullYear(), currentMonth + 1, 0);
    let lastDayOfMonth = nextMonth.getDate();
    // Score change
    // const scored = prework?.score;
    // const OutofScore=100;
    // const scorePercentage = Math.round((scored / OutofScore) * 100);
    //AnalystTable
    let CostofProduct = 100;
    let CostOrderingDelivery = 1500;
    let HoldingCost = 1;
    let RushOrders = 20;
    let LeadTime = 5;
    let SalesPrice = 300;
    let NumberofunitsperOrdering = 50;
    let WorkDays = lastDayOfMonth;
    let SetupCost = 1600;
    let ProfitGoal = 200000;
    let ProfitMargin = 200;
    let MinDemand = 1000;
    const MonthlyDemand = Array.isArray(prework?.attemptdata) && !isNaN(prework?.attemptdata[0]?.demand) ? prework?.attemptdata[0].demand * 30 : 0; 
    // Activity 1 answer
    const answer= {
        qd1: Array.isArray(prework?.attemptdata) && !isNaN(prework?.attemptdata[0]?.demand) ? prework?.attemptdata[0].demand * 30 : 0,
        qs1: 1600,
        qh1:30,
        dd1: Array.isArray(prework?.attemptdata) && !isNaN(prework?.attemptdata[0]?.demand) ? prework?.attemptdata[0].demand * 30 : 0,
        dw1:30,
        ropd1: Array.isArray(prework?.attemptdata) && !isNaN(prework?.attemptdata[0]?.demand) ? (prework?.attemptdata[0].demand * 30) / 30 : 0 ,
        ropl1:5,
    }  
    let activityCompleteScore = 19;
    let activityPartialScore = 0;
    // useEffect(()=>{
    //     console.log(answer)
    // },[])
     //prework Table data-binding to Value
    let remainingOnHandValue = (prework?.attemptdata?.length > 0) ? prework?.attemptdata[prework?.attemptdata?.length - 1]?.remainingOnHand : 0;
    let totalrevenueValue = (prework?.attemptdata?.length > 0) ? prework?.attemptdata?.reduce((total, revitem) => total + parseInt(revitem.revenue), 0) : 0;
    let totalCostValue = (prework?.attemptdata?.length > 0) ? prework?.attemptdata?.reduce((total, totCostitem) => total + parseInt(totCostitem.totalCost), 0) : 0;
    let ProfLossValue = totalrevenueValue - totalCostValue;
    let daysRemaining = (prework?.attemptdata?.length > 0) ? 30 - prework?.attemptdata?.length : 0;
    const handlePopupExitSim = (e) => {
        window.close();
      }
    const save_nextday = (e) => {
        setTimeout(() => {
            if (prework != {}) {

                setIsLoader(false)
                setIsSubmit(false);
                // isRowSaved.current = true;
                if(prework?.attemptdata?.length != preworkValues.preworkTableData?.length){
                    isRowSaved.current = true;
                }

                return;
                // let cpyprework={...prework,["calactdata"]:calculator1};
                // nextday_prework(cpyprework).then((response) => {
                //     if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                //         setError(response?.data)
                //     }
                //     else {
                //         if (typeof response != 'undefined') {
                //             setPrework(response?.data);
                //             setIsLoader(false)
                //             setIsSubmit(false);
                //             if(prework?.attemptdata?.length != preworkValues.preworkTableData?.length){
                //                 isRowSaved.current = true;
                //             }
                //         }
                //     }
                // }).catch((error) => {
                //     // setError("Only instructor can change settings.");
                //     //setError({"id":"00000","msg":"Only instructor can change settings."})
                //     console.log(error);
                // })
            }
        }, 1000)
    }
    const submit_Data=(submittedData)=>{

        setTimeout(() => {
            if (prework != {}) {
                let cpyprework={...submittedData,["calactdata"]:calculator1};
                nextday_prework(cpyprework).then((response) => {
                    if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                        setError(response?.data)
                    }
                    else {
                        if (typeof response != 'undefined') {
                            setPrework(response?.data);
                            setIsLoader(false)
                            setIsSubmit(false);
                            if(submittedData?.attemptdata?.length != preworkValues.preworkTableData?.length){
                                isRowSaved.current = true;
                            }
                        }
                    }
                }).catch((error) => {
                    // setError("Only instructor can change settings.");
                    //setError({"id":"00000","msg":"Only instructor can change settings."})
                    console.log(error);
                })
            }
        }, 1000)
    
}
    const save_Data = (e) => {
        if(!isRequestLoading){
            setIsRequestLoading(true);
        setTimeout(() => {
            if (prework != {}) {
                var copyLastObject=prework.attemptdata[prework.attemptdata.length-1];
                let cpyprework={...prework,["calactdata"]:calculator1,["attemptdata"]: prework.attemptdata.slice(0, -1)};
                // console.log(copyLastObject)
                // console.log(cpyprework);
                nextday_prework(cpyprework).then((response) => {
                    if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                        setError(response?.data)
                    }
                    else {
                        if (typeof response != 'undefined') {
                            if(isToActivateToaster.current){
                                isToActivateToaster.current = false;
                                window.$('#saveToaster').show().transition('fade in');
                                  document.querySelector("#saveToaster").setAttribute("aria-hidden","false");
              
                                  // Hide the message after 5 seconds
                                  setTimeout(function() {
                                    window.$('#saveToaster').transition('fade out').hide();
                                    document.querySelector("#saveToaster").setAttribute("aria-hidden","true")
                                  }, 3000);
                            }
                            let preworkData = {
                                ...response?.data,
                                attemptdata: [...response?.data?.attemptdata, copyLastObject]
                            };
                            setPrework(preworkData);
                            setIsLoader(false)
                            setIsSubmit(false);
                            setIsRequestLoading(false);
                        }
                    }
                }).catch((error) => {
                    // setError("Only instructor can change settings.");
                    //setError({"id":"00000","msg":"Only instructor can change settings."})
                    console.log(error);
                })
            }
        }, 1000)
    }
    }
    const retryPrework = (e) => {
        setTimeout(() => {
            if (prework != {}) {
                retry_prework(prework?.sessionid).then((response) => {
                    
                    if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                        setError(response?.data)
                    }
                    else {
                        if (typeof response != 'undefined' ) {
                            setPrework(response?.data);
                            if(response.status === 200){
                                get_preworkData();
                            }
                            setIsLoader(false)
                            setIsSubmit(false);
                            setTdOrdered('');
                            window.$(".firstHeading").attr("tabindex", "-1").focus();
                            window.$("html, body").animate(
                                {
                                  scrollTop: 0,
                                },
                                100
                              );
                            resetFun();
                            //   const uiLabelprentClass = ImModuleStyle['Activity1-Calculator'];
                            //   document.getElementsByClassName(uiLabelprentClass)[0].classList.remove("disabled")
                            setIssubmitted(false);
                        }
                    }
                }).catch((error) => {
                    // setError("Only instructor can change settings.");
                    //setError({"id":"00000","msg":"Only instructor can change settings."})
                    console.log(error);
                })
            }
        }, 100)
        setResetAllData(true);
    }
    const resetFun =()=>{
        setCalculator1({
            qd1: {  value: '' },
            qs1: {  value: '' },
            qh1: {  value: '' },
            dd1: {  value: '' },
            dw1: {  value: '' },
            ropd1: {  value: '' },
            ropl1: {  value: '' }
          })
    }
    useEffect(() => {
        if(resetAllData){
            setTimeout(() => {
                function getCurrentMonthDates() {
                    let dateStr='';
                    dateStr=prework.creationtime;
                    let currentDate = new Date(dateStr);
                    let currentYear = currentDate.getFullYear();
                    let currentMonth = currentDate.getMonth(); 
                    let daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); // Number of days in the current month
                    let day = 1;
                    let datesArray = [];
                
                    while (datesArray.length != 30) {
                        // Check if current month has fewer days and switch to the next month if necessary
                        if (day > daysInCurrentMonth) {
                            currentMonth++; // Move to the next month
                            day = 1;
                            if (currentMonth > 11) { // Handle year increment
                                currentMonth = 0;
                                currentYear++;
                            }
                            daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
                        }
                
                        let dateObject = {
                            "currentRampDate": `${currentYear}-${(currentMonth + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} 00:00:00`,
                            "demand": Math.floor(Math.random() * (45 - 35 + 1)) + 35,
                            "ordered": "",
                            "received": "",
                            "remainingOnHand": "",
                            "purchaseCost": "",
                            "revenue": "",
                            "holdingCost": "",
                            "orderingCost": "",
                            "stockout": "",
                            "rushOrders": "",
                            "totalCost": "",
                            "ProfitLossValue": ""
                        };
                
                        if (day === 1) {
                            dateObject.revenue = dateObject.demand * 300;
                            dateObject.remainingOnHand = 317;
                            dateObject.holdingCost = 317 * 1;
                            dateObject.totalCost = 317;
                        }
                
                        datesArray.push(dateObject);
                        day++;
                    }
                
                    return datesArray;
                }
            
            // Example usage:
            if(prework.creationtime != undefined){
            currentMonthDates = getCurrentMonthDates();
            //console.log(currentMonthDates)
            //preworkValues.preworkTableData = currentMonthDates;
            setPreworkValues({"preworkTableData":currentMonthDates});
            
                setDefaultPreworkData(preworkValues.preworkTableData[0])
            }    
            }, 100);
        }
}, [resetAllData,preworkValues.preworkTableData,prework.creationtime])

    const get_preworkData = (e) => {
            get_prework().then((response) => {
                if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                    setError(response?.data)
                }
                else {
                    if (typeof response != 'undefined') {
                        setPrework(response?.data);
                        setIsLoader(false)
                        
                        if(prework?.calactdata != null && Object.keys(prework?.calactdata).length !== 0){
                            setPrework(prevPrework => ({
                                ...prevPrework,
                                    calactdata: {
                                        qd1: {  value: '' },
                                        qs1: {  value: '' },
                                        qh1: {  value: '' },
                                        dd1: { value: '' },
                                        dw1: {  value: '' },
                                        ropd1: {  value: '' },
                                        ropl1: {  value: '' }
                                      }
                                
                            }));
                        }
                    }
                }
            }).catch((error) => {
                // setError("Only instructor can change settings.");
                //setError({"id":"00000","msg":"Only instructor can change settings."})
                console.log(error);
            })
    }
    const checkBoxHandler = (e) => {
        const isChecked = e.target.checked;
        setIsChecked(isChecked);
        let checkedOrderCost;
        let checkedTotalCost;
        let ogOrderCost;
        let ogTotalCost;
        let rowDate = window.$(window.$(e.target).closest('tr').find('td')[0]).text();

        if(tdordered != ''){
            if(isChecked === true){
                window.$(window.$(e.target).closest('tr').find('td')[8]).text(`$${formatNum(CostOrderingDelivery + (parseInt(tdordered) * RushOrders))}`);           
                window.$(window.$(e.target).closest('tr').find('td')[11]).text(`$${formatNum(parseInt(tdordered)*CostofProduct + CostOrderingDelivery + (parseInt(window.$(window.$(e.target).closest('tr').find('td')[7]).text().slice(1))) + (parseInt(tdordered) * RushOrders ))}`);
                document.querySelector('tr td input[type="number"][aria-label="Ordered"]').disabled = true;

                //accessibility dynamic msg for checked values
                checkedOrderCost = CostOrderingDelivery + (parseInt(tdordered) * RushOrders);
                checkedTotalCost = parseInt(tdordered)*CostofProduct + CostOrderingDelivery + (parseInt(window.$(window.$(e.target).closest('tr').find('td')[7]).text().slice(1))) + (parseInt(tdordered) * RushOrders );
                window.$("#screen-reader-content").text('');
                let Message2 = `The values have been updated for Ordering Cost: $${checkedOrderCost}, and Total Cost: $${checkedTotalCost} for the row ${rowDate} after Rush Orders checked.`;
                window.$("#screen-reader-content").text(Message2);
            }
            else if(isChecked === false){
                window.$(window.$(e.target).closest('tr').find('td')[8]).text(`$${formatNum(CostOrderingDelivery)}`);
                window.$(window.$(e.target).closest('tr').find('td')[11]).text(`$${formatNum(parseInt(tdordered)*CostofProduct + CostOrderingDelivery + (parseInt(window.$(window.$(e.target).closest('tr').find('td')[7]).text().slice(1))) )}`); 
                document.querySelector('tr td input[type="number"][aria-label="Ordered"]').removeAttribute('disabled');

                //accessibility dynamic msg for unchecked values
                ogOrderCost = CostOrderingDelivery;
                ogTotalCost = parseInt(tdordered)*CostofProduct + CostOrderingDelivery + (parseInt(window.$(window.$(e.target).closest('tr').find('td')[7]).text().slice(1))) ;
                window.$("#screen-reader-content").text('');
                let Message4 = `The values have been updated for Ordering Cost: $${ogOrderCost}, and Total Cost: $${ogTotalCost} for the row ${rowDate}.`;
                window.$("#screen-reader-content").text(Message4);
            }
        }
       
        //setIsChecked(!isChecked)
        //console.log(isChecked ? 'Unchecked' : 'Checked')
    }

    const handleKeyPress = (event) => {
        const charCode = event.charCode || event.keyCode;
        // Allow only numeric input (charCode 48-57 for 0-9)
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    }
    const validateInput = (value) => {
        if (value === '') {
            setErrorMessage(false);
            return;
          }
        const number = parseInt(value, 10);
        if (isNaN(number) || number < 50 || number > 4000 || number % 50 !== 0) {
          setErrorMessage(true);
          (number > 4000)  ? setQty(true) : setQty(false);
        }else {
          setErrorMessage(false);
        }
      };
    const OrderedValidation = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const { value } = e.target;
        const regex = /^[1-9]\d*$/; // Regular expression to match positive integers (1 to 9)
        //console.log("Input value:", value);
        if (value !== '0' && value.length !== 0 && regex.test(value) && value.length <= 4) {
            //console.log("Condition met. Setting tdOrdered to:", Number(value));
            setTdOrdered(Number(value));
            window.$(window.$(e.target).closest('tr').find('td')[5]).text(`$${formatNum(parseInt(value)*CostofProduct)}`);

            //accessibility dynamic msg change
            let rowDate = window.$(window.$(e.target).closest('tr').find('td')[0]).text();
            let purCost = parseInt(value)*CostofProduct;
            let orderCost = CostOrderingDelivery;
            let totalCostValue = parseInt(value)*CostofProduct + CostOrderingDelivery + (parseInt(window.$(window.$(e.target).closest('tr').find('td')[7]).text().slice(1)));
            window.$("#screen-reader-content").text('');
            let Message1 = `The values have been updated for Purchase Cost: $${purCost}, Ordering Cost: $${orderCost}, and Total Cost: $${totalCostValue} for the row ${rowDate}.`;
            window.$("#screen-reader-content").text(Message1);

            if(window.$(e.target)[0].checked === "true"){
                window.$(window.$(e.target).closest('tr').find('td')[8]).text(`$${formatNum(CostOrderingDelivery + (parseInt(tdordered) * RushOrders))}`);
            }
            window.$(window.$(e.target).closest('tr').find('td')[8]).text(`$${formatNum(CostOrderingDelivery)}`);
            window.$(window.$(e.target).closest('tr').find('td')[11]).text(`$${formatNum(parseInt(value)*CostofProduct + CostOrderingDelivery + (parseInt(window.$(window.$(e.target).closest('tr').find('td')[7]).text().slice(1))) )}`);
            validateInput(e.target.value);
        } else {
            setErrorMessage(false)
            setTdOrdered('');
            setIsChecked(false);
            window.$("#screen-reader-content").text('');
            if(isChecked){
                window.$(window.$(e.target).closest('tr').find('td:eq(10) input[type="checkbox"][aria-label="Rush Ordered"]')[0]).checked='false';
            }
            window.$(window.$(e.target).closest('tr').find('td')[5]).text('-');
            window.$(window.$(e.target).closest('tr').find('td')[8]).text('-');
            window.$(window.$(e.target).closest('tr').find('td')[11]).text(`$${formatNum(prework?.attemptdata[prework?.attemptdata?.length - 1].totalCost)}`);
        }
    }
    const preworkStyle = {
        "width": "87.5%",
        "margin": "auto",
        "paddingTop": "15px"
    }
    const formatNum = (num) => {
        return num?.toLocaleString('en-US', { style: 'decimal' });
    }
    const getDate = (date) => {
        // Check if date is provided and is a string
        if (!date || typeof date !== 'string') {
            return "Invalid date";
        }
    
        // Split the input date string
        var parts = date.split(" ")[0].split("-"); // Extracts only date part and splits into year, month, and day
    
        // Check if parts array has expected length
        if (parts.length !== 3) {
            return "Invalid date format";
        }
    
        // Extract year, month, and day
        var year = parts[0].substring(2); // Taking only last two digits of the year
        var month = parseInt(parts[1], 10); // Parsing month as integer
        var day = parseInt(parts[2], 10); // Parsing day as integer
    
        // Check if month and day are valid numbers
        if (isNaN(month) || isNaN(day)) {
            return "Invalid month or day";
        }
    
        // Format the date as required
        var outputDate = month + "/" + day + "/" + year;
    
        return outputDate;
    }
    const closeExpandCalcPopup = () => {
        setIsFromHelp(false);
        setExpandCalcPopup(false);
        if (isCalculatorOpen) {
            setCalculatorPopup((prevCalculator) => ({
                ...prevCalculator,
                ["q"]: true
            }));
        }
        else {
            setSimPrgPopup(true);
        }
    }
    const closeAccordionPopup = () => {
        setAccordionPopup(false);
        setExpandCalcPopup(true);
    }
    const updateInput = (e) => {
        // let regex = e.target.id == "qh" ? /^\d+(\.\d*)?$/ : /^\d*$/
        let regex = e.target.id == "qh" ? /^\d+(\.\d{0,2})?$/ : /^\d*$/
        let { name, value } = e.target;
        let res = 0;
        if (value.indexOf(".") != -1) {
            res = value.split(".")[1].length
        }
        let result = e.target.id == "qh" ? regex.test(parseFloat(value)) && parseFloat(value) <= 9999.99 && res <= 2 : regex.test(value)
        if (['qd', 'qs', 'qh', 'dd', 'dw', 'ropd', 'ropl'].includes(name)) {
            if (result && !(name == "dw" && value == 0) && !(name == "qh" && value == 0) && !isNaN(value) || value === '') {
                setCalculator((prevCalculator) => ({
                    ...prevCalculator,
                    [name]: value,
                }));
            }
        } else {
            setCalculator((prevCalculator) => ({
                ...prevCalculator,
                [name]: value,
            }));
        }
    }
    // Activity 1 onChange function
    const updateInput1 = (e) => {
        let regex = e.target.id == "qh1" ? /^\d+(\.\d{0,2})?$/ : /^\d*$/;
        let { name, value } = e.target;
        let res = 0;
        if (value.indexOf(".") !== -1) {
            res = value.split(".")[1].length;
        }
        let result = e.target.id == "qh1" ? regex.test(parseFloat(value)) && parseFloat(value) <= 9999.99 && res <= 2 : regex.test(value);
    
        if (['qd1', 'qs1', 'qh1', 'dd1', 'dw1', 'ropd1', 'ropl1'].includes(name)) {
            if (result && !(name == "dw1" && value == 0) && !(name == "qh1" && value == 0) && !isNaN(value) || value === '') {
                setCalculator1((prevCalculator) => {
                    // Ensure prevCalculator is initialized
                    if (!prevCalculator) {
                        prevCalculator = {};
                    }
                    let newCalculator = {
                        ...prevCalculator,
                        [name]: { ...prevCalculator[name], value: value }
                    };
                    if (name === 'qd1' || name === 'dd1') {
                        newCalculator.qd1 = { ...newCalculator.qd1, value: value };
                        newCalculator.dd1 = { ...newCalculator.dd1, value: value };
                    }
                    return newCalculator;
                });
            }
        } else {
            setCalculator1((prevCalculator) => ({
                ...prevCalculator,
                [name]: { ...prevCalculator[name], value: value }
            }));
        }
    };
   const compareValues = () => { // for Activity 1 istrue
    
    setCalculator1((prevCalculator) => {
        let newCalculator = { ...prevCalculator };
    
        // First, update existing keys and set `istrue`
        for (let key in newCalculator) {
            if (newCalculator.hasOwnProperty(key)) {
                if (answer.hasOwnProperty(key)) {
                    newCalculator[key].istrue = (parseFloat(newCalculator[key]?.value) === parseFloat(answer[key]));
                } else {
                    newCalculator[key].istrue = false;
                }
            }
        }
    
        // Then, add any missing keys from `answer` to `newCalculator`
        for (let key in answer) {
            if (answer.hasOwnProperty(key) && !newCalculator.hasOwnProperty(key)) {
                newCalculator[key] = {
                    value: '',
                    istrue: false
                };
            }
        }
    
        return newCalculator;
    });
    
};

    
const HandleSubmit_Act1 =()=>{
            setIssubmitted(true);
            let newData = [...prework?.attemptdata];
            let lastRow = newData[newData.length - 1]
            let OrderedValue = parseInt(tdordered) ? parseInt(tdordered) : 0;
            lastRow.ordered = OrderedValue        
            lastRow.purchaseCost = OrderedValue * CostofProduct
            newData[newData.length - 1].orderingCost = OrderedValue != 0 ? isChecked ? CostOrderingDelivery + (parseInt(tdordered) * RushOrders) : CostOrderingDelivery : 0;
            lastRow.totalCost = lastRow.remainingOnHand;
            let CalcTotalCost =  parseInt(lastRow.purchaseCost) + parseInt(lastRow.totalCost) + parseInt(lastRow.orderingCost)
            newData[newData.length - 1].totalCost=CalcTotalCost != '' ? CalcTotalCost : 0;
            newData[newData.length - 1].ProfitLossValue= ProfLossValue;
            isChecked ? lastRow.rushOrders = 'true' : lastRow.rushOrders = 'false'
            hasSubmitted.current=true;
            compareValues();
            setTimeout(() => {
                window.$("#preworkScoreBlock").attr("tabindex","-1").focus();
            }, 1000);
}
    useEffect(() => {
        setHeaderPopup(false);
        let artifactSel = document.querySelector(".artifacts");
        let ApprowSel = document.querySelector(".App .row");
        let FooterIntro = document.querySelector('.footer-nav .footer-links .listitem');
        window.$('.ui.accordion').accordion();
        window.$('html, body').animate({
            scrollTop: 0
        }, 100);
        document.title = "Inventory Management | Prework";
        if (artifactSel !== null) {
            artifactSel.style.display = "none";
        }
        setIsOverlay(false)
        if (ApprowSel !== null) {
            ApprowSel.style.minHeight = "auto";
            ApprowSel.style.minHeight = "100vh";

        }
        if (FooterIntro !== null) {
            FooterIntro.style.display = "none"; //for hide intro navigation
        }
        document.querySelector(".title").textContent = "Inventory Management - Prework";
        const isMacOS = /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent);
        const isFF = /Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent);
        const pwk_table = ImModuleStyle['prework-table'];
        const preworkTableSel = document.getElementsByClassName(pwk_table)[0];

        if (preworkTableSel) {
            if (isMacOS) {
                preworkTableSel.style.setProperty("font-size", "12px", "important");
            } 
            else if(isFF){
                preworkTableSel.style.setProperty("font-size", "12.7px", "important");
            }else {
                preworkTableSel.style.setProperty("font-size", "13.7px", "important");
            }
        }
        let element = document.querySelector('h1.title[aria-hidden="false"][tabindex="-1"]');
        if(element != null){
            element.classList.add('firstHeading');
        }
    }, [])
    
    useEffect(()=>{
        function getCurrentMonthDates() {
            let dateStr='';
            dateStr=prework.creationtime;
            let currentDate = new Date(dateStr);
            let currentYear = currentDate.getFullYear();
            let currentMonth = currentDate.getMonth(); 
            let daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate(); // Number of days in the current month
            let day = 1;
            let datesArray = [];
        
            while (datesArray.length != 30) {
                // Check if current month has fewer days and switch to the next month if necessary
                if (day > daysInCurrentMonth) {
                    currentMonth++; // Move to the next month
                    day = 1;
                    if (currentMonth > 11) { // Handle year increment
                        currentMonth = 0;
                        currentYear++;
                    }
                    daysInCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
                }
        
                let dateObject = {
                    "currentRampDate": `${currentYear}-${(currentMonth + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} 00:00:00`,
                    "demand": Math.floor(Math.random() * (45 - 35 + 1)) + 35,
                    "ordered": "",
                    "received": "",
                    "remainingOnHand": "",
                    "purchaseCost": "",
                    "revenue": "",
                    "holdingCost": "",
                    "orderingCost": "",
                    "stockout": "",
                    "rushOrders": "",
                    "totalCost": "",
                    "ProfitLossValue": ""
                };
        
                if (day === 1) {
                    dateObject.revenue = dateObject.demand * 300;
                    dateObject.remainingOnHand = 317;
                    dateObject.holdingCost = 317 * 1;
                    dateObject.totalCost = 317;
                }
        
                datesArray.push(dateObject);
                day++;
            }
        
            return datesArray;
        } 
        // Example usage:
        if(prework.creationtime != undefined){
            currentMonthDates = getCurrentMonthDates();
            //console.log(currentMonthDates)
            //preworkValues.preworkTableData = currentMonthDates;
            setPreworkValues({"preworkTableData":currentMonthDates});
        }
    }, [prework.creationtime])

    useEffect(()=>{
        if(isSubmit){
            save_nextday();
        }
    },[isSubmit])

    function formatDateTime(date) {
        let year = String(date.getFullYear());
        let month = String(date.getMonth() + 1).padStart(2, '0');
        let day = String(date.getDate()).padStart(2, '0');
        let hours = String(date.getHours()).padStart(2, '0');
        let minutes = String(date.getMinutes()).padStart(2, '0');
        let seconds = String(date.getSeconds()).padStart(2, '0');
        
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const mergeData = (data) => {
        let mergedData = {};

        // Iterate through the array
        data.forEach(item => {
            // Check if the currentRampDate already exists in mergedData
            if (mergedData[item.currentRampDate]) {
                // If yes, add received to the existing value
                mergedData[item.currentRampDate] += item.received;
            } else {
                // If not, add a new entry
                mergedData[item.currentRampDate] = item.received

            }
        });
        return mergedData
    }

    const checkForDelievery = (data,newDataEntry)=> {
        //console.log("Initial Data:", data);
        //console.log("New Data Entry:", newDataEntry);
        // Filter out items where ordered is empty or 0
        const filteredData = data.filter(item => item.ordered && item.ordered !== 0);
    
        // Extract values of currentRampDate and ordered from each object
        const valuesToPush = filteredData.map(item => {
            const currentDate = new Date(item.currentRampDate);
            let futureDate = new Date(currentDate);
            let numberOfDaysToAdd = item.rushOrders === "true" ? 1 : 5;
            futureDate.setDate(currentDate.getDate() + numberOfDaysToAdd);
    
            // Push the current rampdate of a future date after five days
            return { //prev row
                currentRampDate: formatDateTime(futureDate),
                received: item.ordered,
                demand:item.demand,
                remainingOnHand:item.remainingOnHand
            };
        });

        let mergedData = mergeData(valuesToPush);

        // mergedData.map(item => {
        //     if(item.currentRampDate == nextRowToAdd.currentRampDate){
        //         nextRowToAdd.received = item.received
        //     }
        // });

        for (const key in mergedData) {
            if(key == newDataEntry.currentRampDate){
                newDataEntry.received = mergedData[key]
                let availableQty = data[data.length-1].remainingOnHand + newDataEntry.received;
                let soldQty = (availableQty >= newDataEntry.demand) ? newDataEntry.demand : availableQty //revenue
                let remainQty = availableQty - soldQty  //ROH
                let stkoutQty = newDataEntry.demand - soldQty //stockout 
                newDataEntry.remainingOnHand = remainQty>0 ? remainQty : 0;
                newDataEntry.holdingCost = newDataEntry.remainingOnHand * 1;
                newDataEntry.totalCost = newDataEntry.remainingOnHand;
                newDataEntry.stockout= stkoutQty;
            }
        }
        return newDataEntry;
    }

    const getNextRow = ()=> {
        let newData = [...prework?.attemptdata];
        let lastRow = newData[newData.length - 1]

        let newDataEntry = preworkValues.preworkTableData[prework?.attemptdata.length];
         
        let availableQty = newData[newData.length - 1].remainingOnHand + newDataEntry.received; //recevied + ROH(prev) newDataEntry.received
        let soldQty = (availableQty >= newDataEntry.demand) ? newDataEntry.demand : availableQty //revenue
        let remainQty = availableQty - soldQty  //ROH
        let stkoutQty = newDataEntry.demand - soldQty //stockout 
        // Update the 'ordered' property of the current data entry with tdordered value
        
        newDataEntry.revenue = soldQty * SalesPrice;
        newDataEntry.remainingOnHand = remainQty>0 ? remainQty : 0;
        newDataEntry.holdingCost = newDataEntry.remainingOnHand * 1;
        newDataEntry.totalCost = newDataEntry.remainingOnHand;
        newDataEntry.stockout= stkoutQty;

        return newDataEntry;

    }
    const addRow = (e) => {
        isRowAdded.current = true;
        orderDisabled.current=true;
        //let isCompleted=0;
            // Clone the initial data state
            let newData = [...prework?.attemptdata];
            let lastRow = newData[newData.length - 1]

            if (prework?.attemptdata?.length == preworkValues.preworkTableData.length) {
                let OrderedValue = parseInt(tdordered) ? parseInt(tdordered) : 0;
                lastRow.ordered = OrderedValue
                
                lastRow.purchaseCost = OrderedValue * CostofProduct
                newData[newData.length - 1].orderingCost = OrderedValue != 0 ? isChecked ? CostOrderingDelivery + (parseInt(tdordered) * RushOrders) : CostOrderingDelivery : 0;
                lastRow.totalCost = lastRow.remainingOnHand;
                let CalcTotalCost =  parseInt(lastRow.purchaseCost) + parseInt(lastRow.totalCost) + parseInt(lastRow.orderingCost)
                newData[newData.length - 1].totalCost=CalcTotalCost != '' ? CalcTotalCost : 0;
                newData[newData.length - 1].ProfitLossValue= ProfLossValue;
                //isCompleted=1;
            }
            else {
                // Get the current data entry based on the currentIndex
                
                let newDataEntry = getNextRow();
                let OrderedValue = parseInt(tdordered) ? parseInt(tdordered) : 0;
                newData[newData.length - 1].ordered = OrderedValue;
                newData[newData.length - 1].purchaseCost = OrderedValue * CostofProduct;
                newData[newData.length - 1].orderingCost = OrderedValue != 0 ? isChecked ? CostOrderingDelivery + (parseInt(tdordered) * RushOrders) : CostOrderingDelivery : 0;
                let CalcTotalCost = parseInt(lastRow.purchaseCost) + parseInt(lastRow.totalCost) + parseInt(lastRow.orderingCost)
                newData[newData.length - 1].totalCost= CalcTotalCost != '' ? CalcTotalCost : 0;
                newData[newData.length - 1].ProfitLossValue= ProfLossValue;
                isChecked ? lastRow.rushOrders = 'true' : lastRow.rushOrders = 'false'
                // Add the current data entry to the cloned data state
                // newData.push(newDataEntry);
                newDataEntry = checkForDelievery(newData,newDataEntry);
                setNextRowToAdd(newDataEntry)
                //accessibility dynamic msg
                currDateRef.current=newDataEntry.currentRampDate;
            }
            // Update the state with the modified data
            //setData(newData);          
            setTdOrdered('')
            // Increment the currentIndex for the next data entry
            setCurrentIndex(currentIndex + 1);
            // const updatedPrework = { ...prework, attemptdata: newData ,["completed"]: isCompleted};
            // setPrework(updatedPrework);
            setIsSubmit(true);
            isRowSaved.current=true;
            setIsChecked(false)
            setErrorMessage(false);
            shouldRunEffect.current = false; // Prevent useEffect from running
        // isChecked ? data[data.length - 1].rushOrders = 'true' : data[data.length - 1].rushOrders = 'false'
    };
   const CalculateScore1 = () => {
    // Score functionality
    let activity1Score = 0;
    // Check if prework and calactdata are defined
    if (calculator1 && calculator1 != null) {
        // Calculate the count of true values
        let allFilled;
        if(Object.values(calculator1).filter(item => item.istrue).length > 6){
            allFilled=true;
        }
        else{
            allFilled = Object.values(calculator1).every(item => item.istrue !== true && item.value !== '');
        }
        // Check if countTrue is greater than 6
        if (allFilled) {
            let countTrue = Object.values(calculator1).filter(item => item.istrue).length;
            let attemptArray1= (countTrue !== 0) ? countTrue - 1 : 0;
            activity1Score += attemptArray1*2;
            activity1Score += activityCompleteScore;
        } else {
            if(calculator1['qd1'].value != "" && calculator1['dd1'].value != "" && (answer.dd1 == calculator1['dd1'].value) && (answer.qd1 == calculator1['qd1'].value) && (calculator1['qd1'].value == calculator1['dd1'].value) && (calculator1['qd1'].istrue == calculator1['dd1'].istrue)){
                let countTrue = Object.values(calculator1).filter(item => item.istrue).length;
                let attemptArray1= (countTrue !== 0) ? countTrue - 1 : 0;
                activity1Score += attemptArray1*2;
                activity1Score += activityPartialScore;
            }
            else{
                let countTrue = Object.values(calculator1).filter(item => item.istrue).length;
                activity1Score += countTrue*2;
                activity1Score += activityPartialScore;
            }
            
        }
    }
    //&& calculator1.length > 6 && calculator1 != 0
    //console.log("Final activity1Score:", activity1Score);
    return activity1Score;
};
function StockoutCountnegative(arr) { //stockout -ve marking count only.
    let fixedScore=30;
    let negativeCnt = 0;
    let Stockoutscore;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] === 0) {
            negativeCnt += 0; // if current value is 0, do nothing (count += 0)
        } else if (i > 0 && arr[i - 1] === 0) {
            negativeCnt += 3; // if current value is not 0 and previous value was 0, count += 3
        } else {
            negativeCnt += 1; // if current value is not 0 and not after a 0, count += 1
        }
    }
    Stockoutscore = fixedScore - negativeCnt;
    return Stockoutscore;
}
const CalculateScore2 = (newData) => {
    // Score functionality
    let activity2Score = 0;
    let ProfitGoal= 200000;
    let lastRowSubmitted= newData[newData.length-1];
    let salesTargetMedium;
    let sealsTargetDiff;
    let FinalSealsTarget;
    let ActualValue;
    let StockoutCollection = newData.map((item)=> item.stockout === '' ? 0 : item.stockout);
    let countedStkout = StockoutCountnegative(StockoutCollection);
    if(Object.values(newData).length > 0){
        if(prework?.attemptdata?.length === preworkValues.preworkTableData.length){
            activity2Score+=activityCompleteScore;
        }
        if(lastRowSubmitted.ProfitLossValue >= ProfitGoal){
            activity2Score+=20;
        }
        else{
              sealsTargetDiff = ProfitGoal - lastRowSubmitted.ProfitLossValue;
              salesTargetMedium = Math.floor(sealsTargetDiff / 1000);
              FinalSealsTarget = 20 - salesTargetMedium;
              ActualValue = (FinalSealsTarget <= 0) ? 0 : FinalSealsTarget;
              activity2Score+= ActualValue;
        } 
        activity2Score+=countedStkout;    
    }
    //console.log("Final activity2Score:", activity2Score);
    return activity2Score;
};

    useEffect(()=>{
        if(hasSubmitted.current){
            let newData = [...prework?.attemptdata];
            const additionTwoActivities = CalculateScore1() + CalculateScore2(newData)
            // Clone the initial data state
            
            setPrework((prevCopyPrework)=>(
                {
                    ...prevCopyPrework,
                    ['attemptdata']: newData,
                    ['calactdata']:calculator1,
                    ['completed'] : 1,
                    ['score'] : additionTwoActivities
                    }
                ));    
            //setIsSubmit(true)
            const submittedData={...prework,
                ['attemptdata']: newData,
                ['calactdata']:calculator1,
                ['completed'] : 1,
                ['score'] : additionTwoActivities}
                submit_Data(submittedData);
            hasSubmitted.current=false;
        }        
    },[prework,hasSubmitted.current,calculator1])
    useEffect(()=>{
        if(isSave){
            let newData = [...prework?.attemptdata];
            setPrework((prevCopyPrework)=>(
                {
                    ...prevCopyPrework,
                        ['attemptdata']: newData,
                        ['calactdata']:calculator1,
                    }
            )); 
            setIsSave(false);
        }
        // console.log(calculator1);
        // console.log(`prework calculator1`,prework?.calactdata)
    },[setPrework,isSave,calculator1])
    useEffect(()=>{
        if(prework != null && shouldRunEffect.current && !hasSubmitted.current){
             setCalculator1(prework?.calactdata)
            hasSubmitted.current=false;
            shouldRunEffect.current = true; // Reset after useEffect runs
        }
      },[prework,hasSubmitted.current])
    useEffect(()=>{
        if(prework?.completed !== 0 && prework?.status === "COMPLETED"){
            setIssubmitted(true)
        }
    },[prework?.completed])
    useEffect(()=>{
        if(isRowSaved.current && Object.keys(nextRowToAdd).length>0){
            setPrework({...prework,['attemptdata']:[...prework?.attemptdata,nextRowToAdd]})
            setNextRowToAdd({});
            isRowSaved.current = false
        }
    },[isRowSaved.current,prework,nextRowToAdd])
    useEffect(() => {
        if(prework?.attemptdata && preworkValues.preworkTableData.length>0 && !isDataLoaded.current){
            if(prework?.attemptdata?.length == 0){
                //setPrework({...prework,['attemptdata']:[preworkValues.preworkTableData[0]]})
                setDefaultPreworkData(preworkValues.preworkTableData[0])
                isDataLoaded.current = true
            }
            else if((prework?.attemptdata?.length > 0) && !(prework?.status == "COMPLETED" || prework?.completed)){
                let newDataEntry = getNextRow();
                newDataEntry = checkForDelievery(prework?.attemptdata,newDataEntry)
                setPrework({...prework,['attemptdata']:[...prework?.attemptdata,newDataEntry]})
                isDataLoaded.current = true
            }
        }
    }, [prework?.attemptdata,preworkValues.preworkTableData]);
    useEffect(()=>{
        if(Object.keys(defaultPreworkData).length != 0 && Object.keys(prework).length != 0){
            //console.log(`defaultPreworkData`,defaultPreworkData)
            if(prework?.attemptdata?.length == 0){
                const obj = {...defaultPreworkData,'currentRampDate':prework.creationtime.split("-")[0]  + '-' + prework.creationtime.split("-")[1] + '-01 00:00:00' };
                const updatedObj = {...prework,['attemptdata']:[obj]}
                setPrework(updatedObj);
            }
        }
    },[prework,defaultPreworkData])
    //  useEffect(() => {
    //     let localsid = localStorage.getItem("session_id") != null ? localStorage.getItem("session_id") : "";
    //     let sessionId = (window.location.hash != "") ? 
    //     (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
    //         if (sessionId != "") {
    //             localStorage["session_id"] = sessionId;
    //             get_preworkData();
    //             setIsLoader(false);
    //         }
    // }, []);

    useEffect(()=>{
        // debugger;
        if(from && from=="preworkdecisionhistory" && data){
            setPrework(data);
          if(document.querySelector(".footer")){
            document.querySelector(".footer").style.display = "block";
          }
          if(document.querySelector(".sv-components-column.sv-components-container-contentBottom")){
            document.querySelector(".sv-components-column.sv-components-container-contentBottom").style.display = "none";
          }
        }
        else{
          let localsid = getSession() != null ? getSession() : "";
              let sessionId = (window.location.hash != "") ? 
              (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
      
              if (sessionId != "") {
                  setSession(sessionId);
                  get_preworkData();
              }
        }
      },[from,data])

    
    // useEffect(() => {

    //         // setCalculator1((prevCalculator) => ({
    //         //   ...prevCalculator,
    //         //   ["dw1"]: calculator1.dw1 ? calculator1.dw1 : 1, //W
    //         //   qd1: calculator1.qd1 * calculator1.qd1,  //D
    //         //   qs1: calculator1.qs1, //S
    //         //   qh1: calculator1.qh1 ? calculator1.qh1 : 1, //H
    //         //   dd1: calculator1.dd1 * calculator1.dd1, //D
    //         //   ropd1: calculator1.ropd1, //d
    //         //   ropl1: 5 //lead time
    //         // }));
    //         console.log(calculator1)
       
    //  }, [calculator1])
    useEffect(() => {
        if(prework?.attemptdata?.length>0){
            let currentDemand=prework?.attemptdata[prework?.attemptdata?.length - 1]?.demand;
            setCalculator((prevCalculator) => ({
              ...prevCalculator,
              ["dw"]: daysRemaining ? daysRemaining : 1, //W
              qd: currentDemand * daysRemaining,  //D
              qs: SetupCost, //S
              qh: daysRemaining ? daysRemaining : 1, //H
              dd: currentDemand * daysRemaining, //D
              ropd: (currentDemand * daysRemaining / daysRemaining) ? currentDemand * daysRemaining / daysRemaining : 0, //d
              ropl: 5 //lead time
            }));
        }
     }, [prework?.attemptdata])

     useEffect(() => {
        const handleResize = ()=> {
            if(calculatorPopup.q && document.getElementsByClassName(`${ImModuleStyle['calc-custom']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom']}`)[0].clientHeight;
                setCalculatorQPopupTop(-top);
            }
            if(calculatorPopup?.qd && document.getElementsByClassName(`${ImModuleStyle['calc-custom1']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom1']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
                setCalculatorQdPopupTop(-top);
            }
            if(calculatorPopup?.d && document.getElementsByClassName(`${ImModuleStyle['division-calc-custom']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['division-calc-custom']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight - 38;
                setCalculatorDivdPopupTop(-top);
            }
            if(calculatorPopup?.qs && document.getElementsByClassName(`${ImModuleStyle['calc-custom2']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom2']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
                setCalculatorQsPopupTop(-top);
            }
            if(calculatorPopup?.qh && document.getElementsByClassName(`${ImModuleStyle['calc-custom3']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom3']}`)[0].clientHeight;
                setCalculatorQhPopupTop(-top);
            }
            if(calculatorPopup?.q1 && document.getElementsByClassName(`${ImModuleStyle['calc-custom4']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['calc-custom4']}`)[0].clientHeight;
                setCalculatorQ1PopupTop(-top);
            }
            if(calculatorPopup?.dd && document.getElementsByClassName(`${ImModuleStyle['division-calc-custom1']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['division-calc-custom1']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
                setCalculatorDdPopupTop(-top);
            }
            if(calculatorPopup?.dw && document.getElementsByClassName(`${ImModuleStyle['division-calc-custom2']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['division-calc-custom2']}`)[0].clientHeight - 5;
                setCalculatorDwPopupTop(-top);
            }
            if(calculatorPopup?.d1 && document.getElementsByClassName(`${ImModuleStyle['division-calc-custom3']}`)[0] != null){
                let top = document.querySelector(`.accordion .show`).clientHeight;
                setCalculatorD1PopupTop(top);
            }
            if(calculatorPopup?.rop && document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom']}`)[0] != null){
                let top = document.querySelector(`.accordion .show`).clientHeight;
                setCalculatorRopPopupTop(top);
            }
            if(calculatorPopup?.ropd && document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom1']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom1']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 15;
                setCalculatorRopdPopupTop(-top);
            }
            if(calculatorPopup?.ropl && document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom2']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['multi-calc-custom2']}`)[0].clientHeight + document.querySelector(`.accordion .show`).clientHeight + 10;
                setCalculatorRoplPopupTop(-top);
            }
            if(calculatorPopup?.ropl1 && document.getElementsByClassName(`${ImModuleStyle['prework-calc-finish']}`)[0] != null){
                let top = document.getElementsByClassName(`${ImModuleStyle['prework-calc-finish']}`)[0].clientHeight + document.querySelector(`.accordion .item`).clientHeight - document.querySelector(`.accordion .show`).clientHeight - 15;
                setCalculatorRopl1PopupTop(-top);
            }
        }
        window.addEventListener('resize', handleResize);
        handleResize();
      }, [calculatorPopup?.q, calculatorPopup?.qd, calculatorPopup?.d, calculatorPopup?.qs, calculatorPopup?.qh, calculatorPopup?.q1, calculatorPopup?.dd, calculatorPopup?.dw, calculatorPopup?.d1, calculatorPopup?.rop, calculatorPopup?.ropd, calculatorPopup?.ropl, calculatorPopup?.ropl1]);

      useEffect(()=>{
        if(!headerPopup || !isOverlay){
            setTimeout(() => {
                Array.from(document.querySelectorAll(".showBtn")).map((item)=>{
                    item.setAttribute("tabindex","-1")
                })
            }, 1000);
        }
      },[headerPopup,isOverlay])

    //accessibility dynamic msg for new row  
    useEffect(()=>{
        if(prework?.attemptdata && isRowAdded.current){
            let currDate =currDateRef.current;
            window.$("#screen-reader-content").text('');
            let Message3 = (currDate != `Invalid date`) ? `A new row has been added for the date ${getDate(currDate)}, with values updated in the Calculator and Units left: ${remainingOnHandValue}, Days remaining: ${daysRemaining}, Total revenue: $${totalrevenueValue}, Total costs: $${totalCostValue}, and Profit/Loss: $${ProfLossValue}.` : '';
            window.$("#screen-reader-content").text(Message3);
            isRowAdded.current = false;
        }
    },[prework?.attemptdata?.length])
    return (
        <div className="im-prework container" style={preworkStyle}>
            <div className={`${ImModuleStyle.introtext} ${ImModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${ImModuleStyle["ui"]} ${ImModuleStyle["accordion"]} ${ImModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isStepsContainerOpen ? "active" : ""} ${ImModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsStepsContainerOpen(prev => !prev)
                        }}
                        >
                            <h2 id='stepsHeading' className={`${ImModuleStyle['intro-heading']}`}>
                                <span>Steps</span>
                                <button className='chevron-btn' aria-expanded={isStepsContainerOpen} aria-labelledby='stepsHeading'>
                                    {
                                    isStepsContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isStepsContainerOpen ? "active" : ""}`}>
                    <ol className={`${ImModuleStyle['custom-list-ol']}`}>
                    <li>Read scenario and approach.</li>
                    <li>In Activity 1, fill out the blank calculator using the values you were given. You can roll over the variables to get more information to help – keep in mind you may need to do some calculations for some! The results of the equations would typically tell you what to order and when.</li>
                    <li>Use the <span aria-hidden="true">^</span><span className='sr-only'>accordion</span> to collapse the Activity 1 calculator, because you have a new auto-populated calculator to use for Activity 2.</li>
                    <li>In Activity 2, begin managing inventory. Note that you have inventory on hand as indicated for day 1. Remember to use your new new auto-populated calculator in Activity 2.</li>
                    <li>Click on Next Day to proceed to the next day to view the demand, inventory, and other parameters to decide whether to place an order.</li>
                    <li>When you decide to place an order, enter the quantity in the Ordered field for that day, and the tool will automatically calculate your total costs, revenue, profit/loss, and update the inventory once the inventory is received (keep an eye on the lead time, the time it takes you to receive the items in your inventory). Click Next Day to place the order. Keep in mind that it takes time (lead time) to receive the order!</li>
                    <li>Continue this inventory management process for the whole month. Your goals are to not run out of stock, reach your sales target, and maintain a healthy profit margin as in the Targets section. You can keep an eye on these goals at the bottom of the screen.</li>
                    <li>
                                <div>
                                Click the <div style={{'display': 'inline-block'}}><span className={`${ImModuleStyle["custom-button"]} ${ImModuleStyle["save-customBtn"]}`}>Save</span></div> button to keep your progress. Once you’ve finished the assignment, click the <div style={{'display': 'inline-block'}}><span className={`${ImModuleStyle["custom-button"]} ${ImModuleStyle["submit-customBtn"]}`}>Submit</span></div> button to receive your grade and feedback.
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div className={`${ImModuleStyle.introtext} ${ImModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${ImModuleStyle["ui"]} ${ImModuleStyle["accordion"]} ${ImModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isScenarioContainerOpen ? "active" : ""} ${ImModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsScenarioContainerOpen(prev => !prev)
                        }}
                        >
                            <h2 id='scenarioHeading' className={`${ImModuleStyle['intro-heading']}`}>
                                <span>Scenario</span>
                                <button className='chevron-btn' aria-expanded={isScenarioContainerOpen} aria-labelledby='scenarioHeading'>
                                    {
                                    isScenarioContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                    : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isScenarioContainerOpen ? "active" : ""}`}>
                        <p className={`${ImModuleStyle["indent-para"]}`}>In this exercise you will be managing daily inventory of an ultrawide computer monitor for one month, to practice knowing when and how much to reorder at each reorder point. Your goal is to achieve a sales target of $200,000 and not run out of stock.</p>
                    </div>
                </div>
            </div>
            <div className={`${ImModuleStyle.introtext} ${ImModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${ImModuleStyle["ui"]} ${ImModuleStyle["accordion"]} ${ImModuleStyle["prework-tables"]}`}>
                    <div className={`title ${isApproachOpen ? "active" : ""} ${ImModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsApproachOpen(prev => !prev)
                        }}
                        >
                            <h2 id='approachHeading' className={`${ImModuleStyle['intro-heading']}`}>
                                <span>Approach</span>
                                <button className='chevron-btn' aria-expanded={isApproachOpen} aria-labelledby='approachHeading'>
                                    {
                                        isApproachOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                    </div>
                    <div className={`content ${isApproachOpen ? "active" : ""}`}>
                        <p>You first need to fill out the blank calculator formulas with the correct values.  Based on the numbers last period and expected trends this month, your analysts provide the following data about the latest version of the ultrawide computer monitor, which you can use to fill this out:</p>
                        <div className={`${ImModuleStyle['analyst-data']}`}>
                        <table className={`ui celled table ${ImModuleStyle['ui']} ${ImModuleStyle['celled']} ${ImModuleStyle['table']}`} >
                            <tbody>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Cost of Product</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{formatNum(CostofProduct)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Cost of ordering and delivery</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{formatNum(CostOrderingDelivery)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Holding Cost</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{formatNum(HoldingCost)} per day</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Rush Orders</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{formatNum(RushOrders)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Lead Time</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{LeadTime}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className={`ui celled table ${ImModuleStyle['ui']} ${ImModuleStyle['celled']} ${ImModuleStyle['table']}`} >
                            <tbody>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Sales Price</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{formatNum(SalesPrice)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Number of units per order</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{NumberofunitsperOrdering}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Work Days</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>30</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Setup cost</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{SetupCost}</span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <table className={`ui celled table ${ImModuleStyle['ui']} ${ImModuleStyle['celled']} ${ImModuleStyle['table']}`}>
                            <tbody>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Profit Goal</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{formatNum(ProfitGoal)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Profit Margin</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{'\u0024'}{formatNum(ProfitMargin)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Min. Demand Needed</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{formatNum(MinDemand)}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td data-label="Name">
                                        <span className={`${ImModuleStyle['float-left']}`}>Monthly Demand</span>
                                        <span className={`${ImModuleStyle['float-right']}`}>{formatNum(MonthlyDemand)}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                        <div className={`${ImModuleStyle.introtext} ${ImModuleStyle["mbottom"]} ${ImModuleStyle['table-p']}`}>
                            <p>Next you can begin the inventory management process by using a fresh calculator in Activity 2 below. The values will now automatically populate for you.</p>
                            <p>You will begin with some level of existing inventory, but need to be careful to identify when and how much to order!</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className={`${ImModuleStyle.introtext} ${ImModuleStyle["mbottom"]}`}>
                <div className={`ui accordion ${ImModuleStyle["ui"]} ${ImModuleStyle["accordion"]} ${ImModuleStyle["prework-tables"]}`}>
                <div className={`title ${isActivity1Open ? "active" : ""} ${ImModuleStyle["title"]}`}
                        onClick={()=>{
                            setIsActivity1Open(prev => !prev)
                        }}
                        >
                            <h2 id='activity1Heading' className={`${ImModuleStyle['intro-heading']}`}>
                                <span>Activity 1: Populate Calculator</span>
                                <button className='chevron-btn' aria-expanded={isActivity1Open} aria-labelledby='activity1Heading'>
                                    {
                                        isActivity1Open ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                        : <i className={`chevron down icon`} aria-hidden="true"></i>
                                    }
                                </button>
                            </h2>
                </div>
                    <div className={` content ${isActivity1Open ? "active" : ""} ${ImModuleStyle['Activity1-Calculator']}`}>
                            <div className={`content ${ImModuleStyle.content}`}>
                                <div className={`${ImModuleStyle['equation-sections']}`}>
                                    <div className={`${ImModuleStyle['sqrt-sec']}`} >
                                        <div className={`${ImModuleStyle['lhs']}`}>
                                            <div className={`${ImModuleStyle["q-block"]}`}>
                                                <span className="sr-only">
                                                    Q is the Economic Order Quantity. It tells you how much to order.
                                                </span>
                                                <span data-position="top left" data-tooltip='Q is the Economic Order Quantity. It tells you how much to order.'>
                                                    Q
                                                </span>
                                                <span>&nbsp;&nbsp;=</span>
                                            </div>
                                        </div>
                                        <div className={`${ImModuleStyle['rhs']}`}>
                                            <svg height="80" width="235" viewport="0 0 110 300" aria-label="square root" role='img'>
                                                <line x1="0" y1="60" x2="8" y2="60" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                                                <line x1="8" y1="60" x2="15" y2="80" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                                                <line x1="15" y1="80" x2="30" y2="0" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                                                <line x1="30" y1="0" x2="235" y2="0" style={{ "stroke": "gray", "strokeWidth": 2 }}></line>
                                            </svg>
                                            <div className={`${ImModuleStyle['equation']}`}>
                                                <div>
                                                    <div style={{ "position": "relative" }}>2
                                                        <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                                                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} `} style={{ borderRadius:'5px', outline: calculator1?.qd1?.istrue !== undefined ? (calculator1?.qd1?.istrue ? '3px solid #060' : '3px solid #B90000') : '' }}>
                                                            <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='D is monthly demand, the amount of product sold per month. This number is given to you.'>
                                                                <label htmlFor='qd1' aria-hidden="true" data-tooltip="D is monthly demand, the amount of product sold per month. This number is given to you." data-position="top center">D</label>
                                                            </div>
                                                            <input type="text" autoComplete="off" id='qd1' name="qd1" style={{ "width": "50px" }} maxLength="5" value={calculator1?.qd1?.value} onChange={updateInput1} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                                        </div>
                                                        
                                                        <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                                                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}`} style={{ borderRadius:'5px', outline: calculator1?.qs1?.istrue !== undefined ? (calculator1?.qs1?.istrue ? '3px solid #060' : '3px solid #B90000') : '' }}>
                                                            <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the paragraph above.' >
                                                                <label htmlFor='qs1' aria-hidden="true" data-tooltip="S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the paragraph above." data-position="top center">S</label>
                                                            </div>
                                                            <input id='qs1' name="qs1" autoComplete="off" type="text" maxLength="4" value={calculator1?.qs1?.value} onChange={updateInput1} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span aria-label='divided by'><hr role='presentation' aria-hidden={true} /></span>

                                                <div>
                                                    <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}`} style={{ borderRadius:'5px', outline: calculator1?.qh1?.istrue !== undefined ? (calculator1?.qh1?.istrue ? '3px solid #060' : '3px solid #B90000') : '' }}>
                                                        <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the paragraph above, multiplied by the number of days remaining.'>
                                                            <label htmlFor='qh1' aria-hidden="true" data-tooltip="This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the paragraph above, multiplied by the number of days remaining." data-position="top center">H</label>
                                                        </div>
                                                        <input id='qh1' name="qh1" autoComplete="off" type="text" value={calculator1?.qh1?.value} maxLength="7" onChange={updateInput1} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`${ImModuleStyle['result']}`}>
                                            <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='qResult' style={{ "width": "47px" }}>
                                                {
                                                String(Math.round((calculator1?.qd1?.value !== "" && calculator1?.qs1?.value !== "" && calculator1?.qh1?.value !== "") && !isNaN(Math.sqrt(2 * calculator1?.qd1?.value * calculator1?.qs1?.value / calculator1?.qh1?.value)) && Math.sqrt(2 * calculator1?.qd1?.value * calculator1?.qs1?.value / calculator1?.qh1?.value) !== Infinity ? Math.sqrt(2 * calculator1?.qd1?.value * calculator1?.qs1?.value / calculator1?.qh1?.value) : 0))
                                                }</span></p>
                                        </div>
                                    </div>
                                    
                                    
                                    <div className={`${ImModuleStyle['division-sec']}`} style={{ "position": "relative" }}>
                                        <div >
                                            <div className={`${ImModuleStyle['lhs']}`} style={{ "min-width": "30px" }}>
                                                <div>
                                                    <span className="sr-only">
                                                        d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.
                                                    </span>
                                                    <span data-position="top center" data-tooltip='d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.'>
                                                        d
                                                    </span>
                                                    <span>&nbsp;&nbsp;=</span>
                                                </div>
                                            </div>
                                            <div className={`${ImModuleStyle['rhs']}`}>
                                                <div className={`${ImModuleStyle['equation']}`}>
                                                    <div style={{ "position": "relative" }}>
                                                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}`} style={{ borderRadius:'5px', outline: calculator1?.dd1?.istrue !== undefined ? (calculator1?.dd1?.istrue ? '3px solid #060' : '3px solid #B90000') : '' }}>
                                                            <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='D is monthly demand, the amount of product sold per month. This number is given to you.' >
                                                                <label htmlFor='dd1' aria-hidden="true" data-tooltip="D is monthly demand, the amount of product sold per month. This number is given to you." data-position="top center">D</label>
                                                            </div>
                                                            <input id='dd1' name="dd1" autoComplete="off" type="text" style={{ "width": "50px" }} maxLength="5" value={calculator1?.dd1?.value} onChange={updateInput1} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                                        </div>
        
                                                    </div>
                                                    <span aria-label='divided by'><hr role='presentation' aria-hidden={true} /></span>
                                                    <div>
                                                        <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}`} style={{ borderRadius:'5px', outline: calculator1?.dw1?.istrue !== undefined ? (calculator1?.dw1?.istrue ? '3px solid #060' : '3px solid #B90000') : '' }}>
                                                            <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='W is work days remaining in the cycle. At the start of the month, W is 30, but this changes as you move through the selling cycle.' >
                                                                <label htmlFor='dw1' aria-hidden="true" data-tooltip="W is work days remaining in the cycle. At the start of the month, W is 30, but this changes as you move through the selling cycle." data-position="top center">W</label>
                                                            </div>
                                                            <input id='dw1' name="dw1" autoComplete="off" type="text" maxLength="3" value={calculator1?.dw1?.value} onChange={updateInput1} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                                        </div>
                            
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`${ImModuleStyle['result']}`}>
                                                <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='dResult' style={{ "width": "47px" }}>
                                                    {
                                                            String(Math.round((calculator1?.dd1?.value !== "" && calculator1?.dw1?.value !== "") && !isNaN(calculator1?.dd1?.value / calculator1?.dw1?.value) && calculator1?.dd1?.value / calculator1?.dw1?.value !== Infinity ? calculator1?.dd1?.value / calculator1?.dw1?.value : 0))
                                                    }
                                                </span></p>
                                            </div>
                                        </div>
                                        
                                    </div>


                                    <div className={`${ImModuleStyle['multi-sec']}`} style={{ "position": "relative" }}>
                                        <div>
                                            <div className={`${ImModuleStyle['lhs']}`}>
                                                {/* <p aria-description='ROP is your Reorder Point. This is important! It tells you when to place a new order.'><span data-tooltip="ROP is your Reorder Point. This is important! It tells you when to place a new order." data-position="bottom center">ROP</span>&nbsp;&nbsp;=</p> */}

                                                <div>
                                                    <span className="sr-only">
                                                        ROP is your Reorder Point. This is important! It tells you when to place a new order.
                                                    </span>
                                                    <span data-position="top center" data-tooltip='ROP is your Reorder Point. This is important! It tells you when to place a new order.'>
                                                        ROP
                                                    </span>
                                                    <span>&nbsp;&nbsp;=</span>
                                                </div>
                                            </div>
                                            <div className={`${ImModuleStyle['rhs']}`}>
                                                <div style={{ "position": "relative" }}>
                                                    <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} `} style={{ borderRadius:'5px', outline: calculator1?.ropd1?.istrue !== undefined ? (calculator1?.ropd1?.istrue ? '3px solid #060' : '3px solid #B90000') : '' }}>
                                                        <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.' >
                                                            <label htmlFor='ropd1' style={{ 'fontSize': '14px' }} aria-hidden="true" data-tooltip="d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder." data-position="top center">d</label>
                                                        </div>
                                                        <input id='ropd1' name="ropd1" autoComplete="off" type="text" value={calculator1?.ropd1?.value} maxLength="4" onChange={updateInput1} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                                    </div>
                                                    
                                                </div>


                                                <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                                                <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} `} style={{ borderRadius:'5px', outline: calculator1?.ropl1?.istrue !== undefined ? (calculator1?.ropl1?.istrue ? '3px solid #060' : '3px solid #B90000') : '' }}>
                                                    <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order.'>
                                                        <label htmlFor='ropl1' aria-hidden="true" data-tooltip="L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order." data-position="top center">L</label>
                                                    </div>
                                                    <input id='ropl1' name="ropl1" autoComplete="off" type="text" style={{ "width": "20px" }} maxLength="1" value={calculator1?.ropl1?.value} onChange={updateInput1} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                                </div>
                                            </div>
                                            <div className={`${ImModuleStyle['result']}`}>
                                                <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='ropResult'>
                                                    {
                                                        String(Math.round((calculator1?.ropd1?.value !== "" && calculator1?.ropl1?.value !== "" && !isNaN(calculator1?.ropd1?.value) && !isNaN(calculator1?.ropl1?.value)) ? (calculator1?.ropd1?.value * calculator1?.ropl1?.value) : 0))
                                                    }
                                                </span></p>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className={`${ImModuleStyle['calcval-indication']}`}><p><em>Q: Economic Order Quantity; D: Annual Demand; S: Setup cost; H: Holding Cost; d: Average Daily Demand; W: Work days; ROP: Reorder Point. L: Lead time</em></p></div> */}
                                </div>
                            </div>
                    </div>
                </div>
            </div>    
            <div className={`${ImModuleStyle.introtext} ${ImModuleStyle["mbottom"]} ${ImModuleStyle["activity2-block"]}`}>
                <div className={`${ImModuleStyle["activity2-header"]}`}>
                    <h2 className={`${ImModuleStyle['intro-heading']}`}>Activity 2: Manage Inventory</h2>
                </div>
                <div id='screen-reader-content' aria-live='assertive'></div>
                <div className={`ui container ${ImModuleStyle['ui']} ${ImModuleStyle['container']} ${ImModuleStyle['prework-table-container']}`}>
                    <table className={`ui unstackable striped table ${ImModuleStyle['ui']} ${ImModuleStyle['table']} ${ImModuleStyle['prework-table']}`}>
                        <thead>
                            <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Demand</th>
                                <th scope="col">Ordered</th>
                                <th scope="col">Received</th>
                                <th scope="col">Remaining / On hand</th>
                                <th scope="col" className={`custom-width ${ImModuleStyle["custom-width"]}`}>Purchase Cost</th>
                                <th scope="col">Revenue</th>
                                <th scope="col">Holding Cost</th>
                                <th scope="col">Ordering Cost</th>
                                <th scope="col">Stockout</th>
                                <th scope="col">Rush Orders</th>
                                <th scope="col" className={`custom-width ${ImModuleStyle["custom-width"]}`}>Total Cost</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                prework?.attemptdata?.map((item, index) => (
                                    <tr key={index}>
                                        <td data-label="Date">{getDate(item.currentRampDate)}</td>
                                        <td data-label="Demand">{(item.demand != '') ? `${item.demand}` : `-`}</td>
                                        <td data-label="Ordered">
                                            {(index === prework?.attemptdata?.length-1 && !(prework?.completed)) ? ( 
                                                <input
                                                    type="number"
                                                    aria-label="Ordered"
                                                    autoComplete="off"
                                                    value={tdordered}
                                                    id={`${ImModuleStyle.qtyInputOrdered}`}
                                                    step="50"
                                                    onChange={OrderedValidation} onKeyPress={handleKeyPress} disabled={orderDisabled.current || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                                            ) : (
                                                item.ordered != '' && item.ordered != 0 ? (
                                                  item.ordered
                                                ) : (
                                                  <>
                                                    <span aria-hidden="true">-</span>
                                                    <span className="sr-only">blank</span>
                                                  </>
                                                )
                                              )}
                                        </td>
                                        <td data-label="Received">
                                            { item.received != "" ? (item.received) : (
                                                <>
                                                    <span aria-hidden="true">-</span>
                                                    <span className="sr-only">blank</span>
                                                </>
                                            )}
                                        </td>
                                        <td data-label="Remaining / On hand">{(item.remainingOnHand != '') ? `${item.remainingOnHand}` : 0}</td>
                                        <td data-label="Purchase Cost">
                                            {item.purchaseCost != '' ? (
                                                <>
                                                    <span aria-hidden="true">$</span>
                                                    <span>{formatNum(parseInt(item.purchaseCost))}</span>
                                                </>
                                            ) : (
                                                <>
                                                   <span aria-hidden="true">-</span>
                                                   <span className="sr-only">blank</span>
                                                </>
                                            )}
                                        </td>
                                        <td data-label="Revenue">{(item.revenue != '') ? `$${formatNum(parseInt(item.revenue))}` : "$0"}</td>
                                        <td data-label="Holding Cost">{(item.holdingCost != '') ? `$${formatNum(parseInt(item.holdingCost))}` : "$0"}</td>
                                        <td data-label="Ordering Cost">
                                            {item.orderingCost != '' ? (
                                                <>
                                                    <span aria-hidden="true">$</span>
                                                    <span>{formatNum(parseInt(item.orderingCost))}</span>
                                                </>
                                            ) : (
                                                <>
                                                   <span aria-hidden="true">-</span>
                                                   <span className="sr-only">blank</span>
                                                </>
                                            )}
                                        </td>
                                        <td data-label="Stockout">{(item.stockout != '') ? `${item.stockout}` : `0`}</td>
                                        <td data-label="Rush Orders">{index === prework?.attemptdata?.length - 1 ? 
                                        (<input type="checkbox" aria-label="Rush Ordered" autoComplete="off" 
                                            disabled={tdordered != '' ? false : true} 
                                            checked={!(prework?.completed) ? isChecked : item.rushOrders === 'true' ? true : false}
                                            onChange={checkBoxHandler}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    e.target.checked = !e.target.checked;
                                                    checkBoxHandler(e);
                                                }
                                            }}
                                        />) 
                                        : item.rushOrders !== '' ? (<input type="checkbox" aria-label="Rush Ordered" autoComplete="off" disabled={item.rushOrders} checked={item.rushOrders === 'true' ? true : false} readOnly />) 
                                        : ('-')}</td>
                                        <td data-label="Total Cost">{(item.totalCost != '') ? `$${formatNum(parseInt(item.totalCost))}` : "$0"}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <div style={{display:'flex',alignItems:"center",height:"18px"}}>{errorMessage ? (<><img className={`${ImModuleStyle['info-icon']}`} src={info} alt="info" /><p role="alert" className={`${ImModuleStyle['input-errorMsg']}`}>{`Your order size must be  ${qty ? "less than 4,000 units" : "a multiple of 50"}. Please revise your order.`}</p></>) : ""}</div>
            </div>
            <div className={`${ImModuleStyle['simulation']} ${ImModuleStyle['container']} ${ImModuleStyle['prework-btn-container']}`}>
                <button className={`title ui label ${ImModuleStyle.title} ${ImModuleStyle.ui} ${ImModuleStyle.label} ${ImModuleStyle['next-day']}`}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (clickInProgress.current) return;

                        clickInProgress.current = true;
                        setTimeout(() => {
                        clickInProgress.current = false;
                        }, 500); // Adjust the timeout as needed
                        // if(e.target.textContent === 'Retry' && (prework?.completed != 0 && prework?.nextattempt == true)){
                        //     retryPrework();
                        // }
                        //else{
                            // addRow();
                            // setTimeout(() => {
                            //     orderDisabled.current=false;
                            // }, 1000);
                        //}
                        if(e.target.textContent === 'Next Day'){
                            addRow();
                            window.$(e.target.textContent).attr("tabindex","-1").focus();
                            setTimeout(() => {
                                orderDisabled.current=false;
                            }, 1000);
                        }
                        setTdOrdered(e.target.value)
                        return false;
                    }}
                    style={{
                        pointerEvents: (isRequestLoading || prework?.nextattempt == false || orderDisabled.current || !(prework?.mode == "do" || prework?.mode == "preview") || prework?.completed !== 0 || prework?.attemptdata?.length === preworkValues?.preworkTableData?.length != 0) ? 'none' : 'auto',
                        position: 'absolute',
                        backgroundColor: 'rgb(178, 52, 123)',
                        zIndex: 1,
                        width: '90px',
                        cursor: errorMessage ? 'default' : 'pointer',
                        opacity: (isRequestLoading || prework?.nextattempt == false || orderDisabled.current || errorMessage || !(prework?.mode == "do" || prework?.mode == "preview") || prework?.completed !== 0 || prework?.attemptdata?.length === preworkValues?.preworkTableData?.length != 0) ? 0.5 : 1
                    }} disabled={isRequestLoading ||(prework?.nextattempt == false) || orderDisabled.current || errorMessage || !(prework?.mode == "do" || prework?.mode == "preview") || prework?.completed !== 0 || prework?.attemptdata?.length === preworkValues?.preworkTableData?.length != 0} aria-disabled={(prework?.nextattempt == false || orderDisabled.current || errorMessage || prework?.mode === "review" || prework?.completed !== 0 || prework?.attemptdata?.length === preworkValues?.preworkTableData?.length != 0) ? "true" : "false"} >
                    {/* {prework?.attemptdata?.length === preworkValues?.preworkTableData?.length != 0 ? (prework?.completed != 0 && prework?.nextattempt == true) ? `Retry` : `Submit` : `Next Day`} */}
                    Next Day
                </button>
                <div className={`ui vertical accordion menu ${ImModuleStyle.ui} ${ImModuleStyle.vertical} ${ImModuleStyle.accordion} ${ImModuleStyle.menu}`} style={{ width: "auto" }}>
                    <div className={`item ${ImModuleStyle.item}`}>
                        <a href="#" className={`${ImModuleStyle['calc-help-link']} ${calculatorPopup.ropl1 ? "show" : ""}`} style={{ display: "none" }} onClick={(e) => {
                            e.preventDefault();
                            setToggleSimulation(false);
                            setCalculatorPopup((prevCalculator) => ({
                                ...prevCalculator,
                                ["q"]: true
                            }));
                            // isFromHelp ? setIsOverlay(true) : setIsOverlay(false)
                            setIsOverlay(true);
                            setIsFromHelp(true);
                        }}>
                            <img className={`${ImModuleStyle['prework-calc-image']} ${ImModuleStyle['calc-help']}`} src={help} alt="Calculator Help" />
                        </a>
                        <button className={`title ui label ${ImModuleStyle.title} ${ImModuleStyle.ui} ${ImModuleStyle.label} ${calculatorPopup.cal ? "show" : ""}`} style={{ pointerEvents: accordionPopup || calculatorPopup.cal ? "none" : "auto", position: accordionPopup || calculatorPopup.cal ? "relative" : "relative", backgroundColor: accordionPopup || calculatorPopup.cal ? "#fff" : "#c3c3c324", zIndex: accordionPopup || calculatorPopup.cal ? 2 : "auto", float: 'none', left: '93px' }}
                            onClick={(e) => {
                                setIsFromHelp(true);
                                setIsCalculatorOpen(!isCalculatorOpen);
                                setAccordion_Popup(prevState => !prevState);
                                const currTarget = (e.target.hasAttribute("aria-expanded")) ? e.target : e.target.parentNode;
                                if (currTarget.classList.contains(ImModuleStyle.active)) {
                                    currTarget.classList.remove(ImModuleStyle.active);
                                    window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.remove(ImModuleStyle.active)
                                    setTimeout(() => {
                                        window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.remove("active")
                                        window.$(currTarget).closest(".ui.accordion").find(`.content .${ImModuleStyle['equation-sections']}`).addClass("hidden");
                                    }, 300);
                                    currTarget.classList.remove("active")
                                    window.$(currTarget).closest(".ui.accordion").find(`.${ImModuleStyle['calc-help-link']}`)[0].style.display = "none"
                                }
                                else {
                                    currTarget.classList.add(ImModuleStyle.active);
                                    window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.add(ImModuleStyle.active)
                                    setTimeout(() => {
                                        window.$(currTarget).closest(".ui.accordion").find(".content")[0].classList.add("active");
                                        window.$(currTarget).closest(".ui.accordion").find(`.content .${ImModuleStyle['equation-sections']}`).removeClass("hidden");
                                    }, 300);
                                    currTarget.classList.add("active");
                                    window.$(currTarget).closest(".ui.accordion").find(`.${ImModuleStyle['calc-help-link']}`)[0].style.display = "block"
                                }
                            }}
                            aria-expanded={accordion_Popup}>
                            Calculator
                            <i className={`chevron down icon ${ImModuleStyle.icon} ${expandCalcPopup ? "show" : ""}`}></i>
                        </button>
                        {
                            accordionPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label}`} role='dialog' aria-modal="true" aria-label="Calculator popup" tabIndex={-1}>
                                <p>You may want to use the calculator to figure out what your Economic Order Quantity (Q) and Reorder Point (ROP) should be.</p>
                                <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`} >
                                    <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                    <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={closeAccordionPopup} />
                                </div>
                            </div> : ''
                        }
                        {
                            expandCalcPopup ? <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['expand-calc-popup']}`} role='dialog' aria-modal="true" aria-label="Expand calculator popup" tabIndex={-1}>
                                <p>Expand the Calculator, then click the "?" to access a tutorial on how to use this tool.</p>
                                <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`} >
                                    <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                    <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={closeExpandCalcPopup} />
                                </div>
                            </div> : ''
                        }

                        <div className={`content ${ImModuleStyle.content}`}>
                            <div className={`${ImModuleStyle['equation-sections']}`}>
                                <div className={`${ImModuleStyle['sqrt-sec']} ${(calculatorPopup.q || calculatorPopup.q1) ? "show" : ""}`}>
                                    <div className={`${ImModuleStyle['lhs']}`}>
                                        <div className={`${ImModuleStyle["q-block"]}`}>
                                            <span className="sr-only">
                                                Q is the Economic Order Quantity. It tells you how much to order.
                                            </span>
                                            <span data-position="bottom left" data-tooltip='Q is the Economic Order Quantity. It tells you how much to order.'>
                                                Q
                                            </span>
                                            <span>&nbsp;&nbsp;=</span>
                                        </div>
                                    </div>
                                    <div className={`${ImModuleStyle['rhs']}`}>
                                        <svg height="80" width="235" viewport="0 0 110 300" aria-label="square root" role='img'>
                                            <line x1="0" y1="60" x2="8" y2="60" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                                            <line x1="8" y1="60" x2="15" y2="80" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                                            <line x1="15" y1="80" x2="30" y2="0" style={{ "stroke": "gray", "strokeWidth": 1 }}></line>
                                            <line x1="30" y1="0" x2="235" y2="0" style={{ "stroke": "gray", "strokeWidth": 2 }}></line>
                                        </svg>
                                        <div className={`${ImModuleStyle['equation']}`}>
                                            <div>
                                                <div style={{ "position": "relative" }}>2
                                                    <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                                                    <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup.qd ? "show" : ""}`}>
                                                        <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='D is monthly demand, the amount of product sold per month. This number is given to you.'>
                                                            <label htmlFor='qd' aria-hidden="true" data-tooltip="D is monthly demand, the amount of product sold per month. This number is given to you." data-position="bottom center">D</label>
                                                        </div>
                                                        <input type="text" autoComplete="off" id='qd' name="qd" style={{ "width": "50px" }} maxLength="5" value={calculator.qd} onChange={updateInput} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} />
                                                    </div>
                                                    {
                                                        calculatorPopup?.qd && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom1']}`} role='dialog'  aria-modal="true" aria-label="Monthly demand details popup" tabIndex={-1} style={{top: calculatorQdPopupTop+"px"}}>
                                                            <p>
                                                                D is monthly demand, the amount of product sold per month. This is a read only field, and it will be calculated automatically.
                                                            </p>
                                                            <div className={`mt10 dflex`}>
                                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                                <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                                    setCalculatorPopup((prevCalculator) => ({
                                                                        ...prevCalculator,
                                                                        ["qd"]: false,
                                                                        ["qs"]: true
                                                                    }));
                                                                }} />
                                                            </div>
                                                        </div>
                                                    }
                                                    <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                                                    <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup.qs ? "show" : ""}`}>
                                                        <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the paragraph above.' >
                                                            <label htmlFor='qs' aria-hidden="true" data-tooltip="S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the paragraph above." data-position="bottom center">S</label>
                                                        </div>
                                                        <input id='qs' name="qs" autoComplete="off" type="text" maxLength="4" value={calculator.qs} onChange={updateInput} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} />
                                                    </div>
                                                    {
                                                        calculatorPopup?.qs && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom2']}`} role='dialog' aria-modal="true" aria-label="Setup cost popup" tabIndex={-1} style={{top: calculatorQsPopupTop+"px"}}>
                                                            <p>
                                                                S is Setup Cost, how much it costs to order and deliver the product. This is a constant price you can find in the paragraph above.
                                                            </p>
                                                            <div className={`mt10 dflex`}>
                                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                                <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                                    setCalculatorPopup((prevCalculator) => ({
                                                                        ...prevCalculator,
                                                                        ["qs"]: false,
                                                                        ["qh"]: true
                                                                    }));
                                                                }} />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <span aria-label='divided by'><hr role='presentation' aria-hidden={true} /></span>

                                            <div>
                                                <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup.qh ? "show" : ""}`}>
                                                    <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the paragraph above, multiplied by the number of days remaining.'>
                                                        <label htmlFor='qh' aria-hidden="true" data-tooltip="This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the paragraph above, multiplied by the number of days remaining." data-position="bottom center">H</label>
                                                    </div>
                                                    <input id='qh' name="qh" autoComplete="off" type="text" value={calculator.qh} maxLength="7" onChange={updateInput} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} />
                                                </div>
                                                {
                                                    calculatorPopup?.qh && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom3']} ${ImModuleStyle['holdigcost-popup']}`} role='dialog' aria-modal="true" aria-label="Holding cost popup" tabIndex={-1} style={{top: calculatorQhPopupTop +"px"}}>
                                                        <p>
                                                        This is Holding Cost, or how much it costs to hold the inventory of the product.  It is a daily cost.  This is a constant price you can find in the paragraph above, multiplied by the number of days remaining.
                                                        </p>
                                                        <div className={`mt10 dflex`}>
                                                            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                            <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                                setCalculatorPopup((prevCalculator) => ({
                                                                    ...prevCalculator,
                                                                    ["qh"]: false,
                                                                    ["q1"]: true
                                                                }));
                                                            }} />
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`${ImModuleStyle['result']}`}>
                                        <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='qResult' style={{ "width": "47px" }}>
                                            {
                                                String(Math.round((calculator.qd !== "" && calculator.qs !== "" && calculator.qh !== "") && Math.sqrt(2 * calculator.qd * calculator.qs / calculator.qh) != "Infinity" ? Math.sqrt(2 * calculator.qd * calculator.qs / calculator.qh) : ""))
                                            }</span></p>
                                    </div>
                                </div>
                                {
                                    calculatorPopup?.q && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom']}`} role='dialog' aria-modal="true" aria-label="Economic order quantity popup"  tabIndex={-1} style={{top: calculatorQPopupTop+"px"}}>
                                        <p>
                                            Q is the Economic Order Quantity. It tells you how much to order.
                                        </p>
                                        <div className={`mt10 dflex`}>
                                            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                            <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                setCalculatorPopup((prevCalculator) => ({
                                                    ...prevCalculator,
                                                    ["q"]: false,
                                                    ["qd"]: true
                                                }));
                                            }} />
                                        </div>
                                    </div>
                                }
                                {
                                    calculatorPopup?.q1 && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['calc-custom4']} ${ImModuleStyle['calc-q']}`} role='dialog' aria-modal="true" aria-label="EOQ calculation popup" tabIndex={-1} style={{top: calculatorQ1PopupTop +"px"}}>
                                        <p>
                                            Plug in your constant Set up cost (S), and your constant Holding Cost (H) to run this calculation. Q tells you how much should order.
                                        </p>
                                        <div className={`mt10 dflex`}>
                                            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                            <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                setCalculatorPopup((prevCalculator) => ({
                                                    ...prevCalculator,
                                                    ["q1"]: false,
                                                    ["d"]: true
                                                }));
                                            }} />
                                        </div>
                                    </div>
                                }
                                <div className={`${ImModuleStyle['division-sec']}`} style={{ "position": "relative" }}>
                                    <div className={`${(calculatorPopup.d || calculatorPopup.d1) ? "show" : ""}`} >
                                        <div className={`${ImModuleStyle['lhs']}`} style={{ "width": "25px" }}>
                                            <div>
                                                <span className="sr-only">
                                                    d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.
                                                </span>
                                                <span data-position="bottom center" data-tooltip='d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.'>
                                                    d
                                                </span>
                                                <span>&nbsp;&nbsp;=</span>
                                            </div>
                                        </div>
                                        <div className={`${ImModuleStyle['rhs']}`}>
                                            <div className={`${ImModuleStyle['equation']}`}>
                                                <div style={{ "position": "relative" }}>
                                                    <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']} ${calculatorPopup.dd ? "show" : ""}`}>
                                                        <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='D is monthly demand, the amount of product sold per month. This number is given to you.' >
                                                            <label htmlFor='dd' aria-hidden="true" data-tooltip="D is monthly demand, the amount of product sold per month. This number is given to you." data-position="bottom center">D</label>
                                                        </div>
                                                        <input id='dd' name="dd" autoComplete="off" type="text" style={{ "width": "50px" }} maxLength="5" value={calculator.dd} onChange={updateInput} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} />
                                                    </div>
                                                    {
                                                        calculatorPopup?.dd && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom1']} ${ImModuleStyle['divisn-popup']}`} role='dialog' aria-modal="true" aria-label="Monthly demand popup" tabIndex={-1} style={{top: calculatorDdPopupTop+"px"}}>
                                                            <p>
                                                                D is monthly demand from before here. This is a read only field, and will be calculated automatically.
                                                            </p>
                                                            <div className={`mt10 dflex`}>
                                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                                <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                                    setCalculatorPopup((prevCalculator) => ({
                                                                        ...prevCalculator,
                                                                        ["dd"]: false,
                                                                        ["dw"]: true
                                                                    }));
                                                                }} />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                                <span aria-label='divided by'><hr role='presentation' aria-hidden={true} /></span>
                                                <div>
                                                    <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}  ${calculatorPopup.dw ? "show" : ""}`}>
                                                        <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='W is work days remaining in the cycle. At the start of the month, W is 30, but this changes as you move through the selling cycle.' >
                                                            <label htmlFor='dw' aria-hidden="true" data-tooltip="W is work days remaining in the cycle. At the start of the month, W is 30, but this changes as you move through the selling cycle." data-position="bottom center">W</label>
                                                        </div>
                                                        <input id='dw' name="dw" autoComplete="off" type="text" maxLength="3" value={calculator.dw} onChange={updateInput} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} />
                                                    </div>
                                                    {
                                                        calculatorPopup?.dw && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom2']} ${ImModuleStyle['w-popup']}`} role='dialog' aria-modal="true" aria-label="Work days remaining popup" tabIndex={-1} style={{top: calculatorDwPopupTop+"px"}}>
                                                            <p>
                                                                W is work days remaining in the cycle. At the start of the month, W is 30, but this changes as you move through the selling cycle.
                                                            </p>
                                                            <div className={`mt10 dflex`}>
                                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                                <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                                    setCalculatorPopup((prevCalculator) => ({
                                                                        ...prevCalculator,
                                                                        ["dw"]: false,
                                                                        ["d1"]: true
                                                                    }));
                                                                }} />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`${ImModuleStyle['result']}`}>
                                            <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='dResult' style={{ "width": "47px" }}>
                                                {
                                                    String(Math.round((calculator.dd !== "" && calculator.dw !== "") && (calculator.dd / calculator.dw) != "Infinity" ? (calculator.dd / calculator.dw) : ""))
                                                }
                                            </span></p>
                                        </div>
                                    </div>
                                    {
                                        calculatorPopup?.d && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom']} ${ImModuleStyle['d-popup']}`} role='dialog' aria-modal="true" aria-label="Estimated daily demand popup" tabIndex={-1} style={{top: calculatorDivdPopupTop+"px"}}>
                                            <p>
                                                d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.
                                            </p>
                                            <div className={`mt10 dflex`}>
                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                    setCalculatorPopup((prevCalculator) => ({
                                                        ...prevCalculator,
                                                        ["d"]: false,
                                                        ["dd"]: true
                                                    }));
                                                }} />
                                            </div>
                                        </div>
                                    }
                                    {
                                        calculatorPopup?.d1 && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['division-calc-custom3']} ${ImModuleStyle['cal-d-popup']}`} role='dialog' aria-modal="true" aria-label="Daily demand calculation popup" tabIndex={-1} style={{top: calculatorD1PopupTop+"px"}}>
                                            <p>
                                                To get d, divide Monthly Demand (D) by Working Days remaining (W).
                                            </p>
                                            <div className={`mt10 dflex`}>
                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                    setCalculatorPopup((prevCalculator) => ({
                                                        ...prevCalculator,
                                                        ["d1"]: false,
                                                        ["rop"]: true
                                                    }));
                                                }} />
                                            </div>
                                        </div>
                                    }

                                </div>


                                <div className={`${ImModuleStyle['multi-sec']}`} style={{ "position": "relative" }}>
                                    <div className={`${calculatorPopup.rop ? "show" : ""}`}>
                                        <div className={`${ImModuleStyle['lhs']}`}>
                                            {/* <p aria-description='ROP is your Reorder Point. This is important! It tells you when to place a new order.'><span data-tooltip="ROP is your Reorder Point. This is important! It tells you when to place a new order." data-position="bottom center">ROP</span>&nbsp;&nbsp;=</p> */}

                                            <div>
                                                <span className="sr-only">
                                                    ROP is your Reorder Point. This is important! It tells you when to place a new order.
                                                </span>
                                                <span data-position="bottom center" data-tooltip='ROP is your Reorder Point. This is important! It tells you when to place a new order.'>
                                                    ROP
                                                </span>
                                                <span>&nbsp;&nbsp;=</span>
                                            </div>
                                        </div>
                                        <div className={`${ImModuleStyle['rhs']}`}>
                                            <div style={{ "position": "relative" }}>
                                                <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}  ${calculatorPopup.ropd ? "show" : ""}`}>
                                                    <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder.' >
                                                        <label htmlFor='ropd' style={{ 'fontSize': '14px' }} aria-hidden="true" data-tooltip="d is estimated Daily Demand. If you notice demand being higher or lower, that may affect when you want to reorder." data-position="bottom center">d</label>
                                                    </div>
                                                    <input id='ropd' name="ropd" autoComplete="off" type="text" value={calculator.ropd} maxLength="3" onChange={updateInput} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} />
                                                </div>
                                                {
                                                    calculatorPopup?.ropd && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['multi-calc-custom1']} ${ImModuleStyle['daily-demand-popup']}`} role='dialog' aria-modal="true" aria-label="Daily demand popup" tabIndex={-1} style={{top : calculatorRopdPopupTop+"px"}}>
                                                        <p>
                                                            Use your daily demand here.
                                                        </p>
                                                        <div className={`mt10 dflex`}>
                                                            <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                            <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                                setCalculatorPopup((prevCalculator) => ({
                                                                    ...prevCalculator,
                                                                    ["ropd"]: false,
                                                                    ["ropl"]: true
                                                                }));
                                                            }} />
                                                        </div>
                                                    </div>
                                                }
                                            </div>


                                            <span className={`${ImModuleStyle['cross']}`} aria-label='multiplied by'><span aria-hidden={true}>x</span></span>
                                            <div className={`ui labeled input ${ImModuleStyle['ui']} ${ImModuleStyle['labeled']} ${ImModuleStyle['input']}  ${calculatorPopup.ropl ? "show" : ""}`}>
                                                <div className={`ui label ${ImModuleStyle['ui']} ${ImModuleStyle['label']}`} aria-label='L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order.'>
                                                    <label htmlFor='ropl' aria-hidden="true" data-tooltip="L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order." data-position="bottom center">L</label>
                                                </div>
                                                <input id='ropl' name="ropl" autoComplete="off" type="text" style={{ "width": "20px" }} maxLength="1" value={calculator.ropl} onChange={updateInput} disabled={prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")} />
                                            </div>
                                            {
                                                calculatorPopup?.ropl && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['multi-calc-custom2']} ${ImModuleStyle["prework-multiply"]}`} role='dialog' aria-modal="true" aria-label="Lead time popup" tabIndex={-1} style={{top: calculatorRoplPopupTop+"px"}}>
                                                    <p>
                                                        L is Lead time, or the time it takes your order to be available in inventory. L is a constant 5 days unless you pay extra for an expedited order.
                                                    </p>
                                                    <div className={`mt10 dflex`}>
                                                        <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                        <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                            setCalculatorPopup((prevCalculator) => ({
                                                                ...prevCalculator,
                                                                ["ropl"]: false,
                                                                ["ropl1"]: true
                                                            }));
                                                        }} />
                                                    </div>
                                                </div>
                                            }
                                            {
                                                calculatorPopup?.ropl1 && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['prework-calc-finish']} ${ImModuleStyle['finish-popup']}`} role='dialog' aria-modal="true" aria-label="Minimize calculator popup"  tabIndex={-1} style={{top: calculatorRopl1PopupTop+"px"}}>
                                                    <p>
                                                        When you don't need it, you can minimize the calcu-lator. When you do need it, pause the sim and revisit the calculator to recalculate these values as needed.
                                                    </p>
                                                    {
                                                        isFromHelp ? <div className={`mt10 dflex`}>
                                                            <Button btnName="Finish" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                                setCalculatorPopup((prevCalculator) => ({
                                                                    ...prevCalculator,
                                                                    ["ropl1"]: false,
                                                                }));
                                                                setIsOverlay(false);
                                                                setIsFromHelp(false);
                                                            }} />
                                                        </div>
                                                            :
                                                            <div className={`${ImModuleStyle.mt10} ${ImModuleStyle.dflex}`} >
                                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                                <Button btnName="Next" btnId="btnNext" btnParentClassName={`${ImModuleStyle.ml10}`} btnWidth="80" clickEventHandler={() => {
                                                                    setCalculatorPopup((prevCalculator) => ({
                                                                        ...prevCalculator,
                                                                        ["ropl"]: false
                                                                    }));
                                                                    setIsFromHelp(false);
                                                                    setSimPrgPopup(true);
                                                                    // setIsOverlay(false);
                                                                }} />
                                                            </div>
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div className={`${ImModuleStyle['result']}`}>
                                            <p><span className={`${ImModuleStyle['equalSign']}`}>=</span><span id='ropResult'>
                                                {
                                                    String(Math.round((calculator.ropd !== "" && calculator.ropl !== "") && calculator.ropd * calculator.ropl))
                                                }
                                            </span></p>
                                        </div>
                                    </div>
                                    {
                                        calculatorPopup?.rop && <div className={`ui pointing label ${ImModuleStyle.ui} ${ImModuleStyle.pointing} ${ImModuleStyle.label} ${ImModuleStyle['multi-calc-custom']}`} role='dialog' aria-modal="true" aria-label="R O P popup"  tabIndex={-1} style={{top: calculatorRopPopupTop+"px"}}>
                                            <p>
                                                ROP is your daily demand (d) multiplied by your Lead time (L).
                                            </p>
                                            <div className={`mt10 dflex`}>
                                                <Button btnName="Skip Walk-Thru" btnWidth="130" clickEventHandler={skipWalkThruPopups} />
                                                <Button btnName="Next" btnParentClassName={`ml10`} btnId="btnNext1" btnWidth="80" clickEventHandler={() => {
                                                    setCalculatorPopup((prevCalculator) => ({
                                                        ...prevCalculator,
                                                        ["rop"]: false,
                                                        ["ropd"]: true
                                                    }));
                                                }} />
                                            </div>
                                        </div>
                                    }
                                </div>
                                {/* <div className={`${ImModuleStyle['calcval-indication']}`}><p><em>Q: Economic Order Quantity; D: Annual Demand; S: Setup cost; H: Holding Cost; d: Average Daily Demand; W: Work days; ROP: Reorder Point. L: Lead time</em></p></div> */}
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            <div className={`${ImModuleStyle['prework-profit-loss']}`}>
                <div className={`${ImModuleStyle['profit-loss']}`} style={{ "position": "relative" }}>
                    <div>
                        <div className={`${`${ImModuleStyle['units-left']}`}`}>
                            <h3 className={`${ImModuleStyle['pl-header']}`}>Units Left</h3>
                            <p className={`us-content ${ImModuleStyle.bld}`}>{formatNum(remainingOnHandValue)}</p>
                        </div>
                        <div className={`demand`}>
                            <h3 className={`${ImModuleStyle['pl-header']}`}>Days Remaining</h3>
                            <p className={`us-content tc-content ${ImModuleStyle.bld}`}>{daysRemaining}</p>
                        </div>

                        <div className={`tot-revenue`}>
                            <h3 className={`${ImModuleStyle['pl-header']}`}>Total Revenue</h3>
                            <p className={`tr-content tc-content ${ImModuleStyle.bld}`}>${formatNum(totalrevenueValue)}</p>
                        </div>
                        <div className={`tot-costs`}>
                            <h3 className={`${ImModuleStyle['pl-header']}`}>Total Costs</h3>
                            <p className={`tc-content ${ImModuleStyle.bld}`}>${formatNum(totalCostValue)}</p>
                        </div>
                        <div className={`${ImModuleStyle['pl-progress']}`}>
                            <h3 className={`${ImModuleStyle['pl-header']}`}>Profit/Loss</h3>
                            <p className={`${ImModuleStyle['pl-amt']} ${ImModuleStyle.bld}`} style={{ "color": (ProfLossValue < 0) ? '#B90000' : (ProfLossValue == undefined || ProfLossValue == 0) ? "#000" : '#156815' }}>${formatNum((ProfLossValue == undefined) ? 0 : Math.round(ProfLossValue))}</p>
                        </div>
                    </div>

                </div>
            </div>
        <div className={`${ImModuleStyle["btn-container"]}`}>
            <div className={`${ImModuleStyle["submitsaveContainer"]}`}>
        {
                !(prework?.completed) ?
                <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={(e) => {
                        if (clickInProgress.current) return;

                        clickInProgress.current = true;
                        setTimeout(() => {
                        clickInProgress.current = false;
                        }, 500); // Adjust the timeout as needed
                        
                        if(e.target.textContent === 'Save'){
                            setIsSave(true);
                            save_Data();
                            isToActivateToaster.current = true;
                            setTimeout(() => {
                                orderDisabled.current=false;
                            }, 1000);
                        }
                        //setTdOrdered(e.target.value)
                        return false;
                    }} 
                    customBtnStyle={{
                    zIndex: 1,
                    pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                    width: '90px',
                    cursor: 'pointer',
                    marginLeft: '20px'
                    }}
                    disabled={isRequestLoading || (prework?.nextattempt == false) || orderDisabled.current || errorMessage || prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                    btnName={"Save"}
                />
                :""
            }
            {
                !(prework?.completed) ?
                <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        if(e.target.textContent === 'Submit'){
                            HandleSubmit_Act1();
                        }
                        setTdOrdered(e.target.value)
                        return false;
                    }} 
                    customBtnStyle={{
                    zIndex: 1,
                    pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                    width: '90px',
                    cursor: 'pointer',
                    marginLeft: '20px'
                    }}
                    disabled={isRequestLoading || (prework?.nextattempt == false) || orderDisabled.current || errorMessage || prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                    btnName={"Submit"}
                />
                :""
            }
            </div>
            <div id="saveToaster" role="alert" className={`ui message ${ImModuleStyle['save-toaster']}`} style={{"display": "none"}}>
                <p>Your data is saved, to complete activity please click on Submit.</p>
            </div>
            {
                (prework?.completed && prework?.hasOwnProperty('score')) ?
                <div className={`${ImModuleStyle["score-container"]}`}>
                    <div className={`${ImModuleStyle["score-div"]}`} id="preworkScoreBlock">
                        {/* Score: {scorePercentage}% ({scored}/{OutofScore} points) */}
                        Score: {prework?.score}% ({prework?.score}/{100} points)
                    </div>
                    <div className={`${ImModuleStyle["completionbar"]}`}>Click 
                    <Button 
                            btnClass={`title ui label`}   
                            clickEventHandler={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if(e.target.textContent === 'Retry' && (prework?.completed != 0 && prework?.nextattempt == true)){
                                    retryPrework();
                                }
                                return false;
                            }} 
                            customBtnStyle={{
                                pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                                zIndex: 1,
                                cursor: 'pointer',
                                marginLeft: '20px',
                                width: '75px',
                                opacity: (isRequestLoading) ? 0.5 : 1,
                                margin: "3px 8px",
                                marginLeft : "8px"
                            }}
                            btnParentStyle={{display:"block"}}
                            btnName={"Retry"}
                            disabled={!(prework?.mode == "do" || prework?.mode == "preview")}
                    />
                    to attempt again <strong>(remaining attempts: {prework?.remattempt})</strong>. Click 
                    <Button 
                    btnClass={`title ui label`}   
                    clickEventHandler={handlePopupExitSim} 
                    customBtnStyle={{
                        zIndex: 1,
                        cursor: 'pointer',
                        marginLeft: '20px',
                        width: '75px',
                        margin: "3px 8px",
                        marginLeft : "8px"
                    }}
                    btnParentStyle={{display:"block"}}
                    btnName={"Close"}
                    />
                        to exit.</div>
                </div>
                : ""
            }
        </div>
    </div>
    )
}
export default Prework;